<template>
  <div class="createOrder-page full-height">
    <full-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">{{ $t('notFound.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('createOrder.createOrder1') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="full" class="full-height display-col">
        <el-row>
          <el-col :span="12" class="row-left">
            <el-row>
              <el-col :span="4" class="Accessories-title">{{ $t('createOrder.createOrder2') }}: </el-col>
              <el-col :span="20" class="Accessories">
                <el-row>
                  <el-col :span="6"> {{ $t('createOrder.createOrder3') }}： </el-col>
                  <el-col :span="6">
                    {{ userInfo.paperLabelCount }}
                  </el-col>
                  <el-col :span="6"> {{ $t('createOrder.createOrder4') }}： </el-col>
                  <el-col :span="6">
                    {{ userInfo.washingMark }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6"> {{ $t('createOrder.createOrder5') }}： </el-col>
                  <el-col :span="6">
                    {{ userInfo.signCount }}
                  </el-col>
                  <el-col :span="6"> {{ $t('createOrder.createOrder6') }}： </el-col>
                  <el-col :span="6">
                    {{ userInfo.accessoriesCount }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="row-right">
            <div class="search-btn-container" style="padding-top: 10px">
              <el-button class="search-btn btn-blue" @click="handleOpenDialog">{{$t('createOrder.createOrder101')}}</el-button>
              <span style="display: inline-block; padding-right: 20px; padding-top: 6px"
                class="">{{ $t('createOrder.createOrder7') }}：{{ userInfo.balance }}元</span>
              <el-button class="form-btn btn-green" @click="toRecharge">{{ $t('createOrder.createOrder8') }}</el-button>
              <el-button class="search-btn btn-blue" @click="downloadTemplate">{{ $t('address.address42') }}</el-button>
              <el-upload style="float: right" action="" :on-preview="handlePreview" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-success="handleOrderInfo" multiple :show-file-list="false" :limit="1"
                :on-exceed="handleExceed" :file-list="fileList" :http-request="excelUploadRequest">
                <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder9') }}</el-button>
              </el-upload>
            </div>
          </el-col>
        </el-row>
        <el-form :model="addFormInfo" ref="addForm" label-width="auto" class="add-form full-height display-col flex1">
          <el-table :data="addFormInfo.tableData" :key="randomKey" border :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle" style="width: 100%" height="550">
            <el-table-column :label="$t('createOrder.createOrder10')" width="55">
              <template v-slot="scope">
                <el-button class="list-btn btn-red" @click="delOrder(scope.row, scope.$index)">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="trackingNumberCn" :label="$t('createOrder.createOrder11')" width="100">
              <template slot-scope="scope">
                <el-form-item class="mini-label" label=" " v-if="scope.row.agentFlag + '' === '0'"
                  :prop="'tableData.' + scope.$index + '.trackingNumberCn'"
                  :rules="addFormInfo.addFormInfoRules[scope.$index].trackingNumberCn">
                  <el-input v-model="scope.row.trackingNumberCn" maxlength="50" size="small"></el-input>
                  <!--                  <span v-show="trackingNumberCnType"  size="small"></span>-->
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="taobaoUrl" :label="$t('createOrder.createOrder12')" min-width="150">
              <template slot-scope="scope">
                <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.taobaoUrl'">
                  <el-input v-model="scope.row.taobaoUrl" size="small" @blur="blurTaobaoUrl(scope.row.taobaoUrl, scope.$index)"
                    clearable></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('createOrder.createOrder13')" min-width="230">
              <template slot-scope="scope">
                <div class="style-table">
                  <el-row>
                    <el-form-item :label="$t('createOrder.createOrder116')" :prop="'tableData.' + scope.$index + '.goodsName'"
                      :rules="addFormInfo.addFormInfoRules[scope.$index].goodsName">
                      <el-input v-model="scope.row.goodsName" size="small" clearable></el-input>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item :label="$t('createOrder.createOrder15')" :prop="'tableData.' + scope.$index + '.goodsCount'"
                        :rules="addFormInfo.addFormInfoRules[scope.$index].goodsCount">
                        <el-input v-model="scope.row.goodsCount" size="small" type="number" @mousewheel.native.prevent></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('createOrder.createOrder16')" :prop="'tableData.' + scope.$index + '.price'"
                        :rules="addFormInfo.addFormInfoRules[scope.$index].price">
                        <el-input v-model="scope.row.price" size="small" type="number" @mousewheel.native.prevent></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item :label="$t('createOrder.createOrder17')" :prop="'tableData.' + scope.$index + '.colour'"
                        :rules="addFormInfo.addFormInfoRules[scope.$index].colour">
                        <el-input v-model="scope.row.colour" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('createOrder.createOrder18')">
                        <el-input v-model="scope.row.goodsSize" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-form-item :label="$t('createOrder.createOrder19')" :prop="'tableData.' + scope.$index + '.goodsNumber'">
                      <el-input v-model="scope.row.goodsNumber" size="small"></el-input>
                    </el-form-item>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="chineseFreightFee" :label="$t('createOrder.createOrder112')" width="110">
              <template slot-scope="scope">
                <el-form-item class="mini-label" label=' ' :prop="'tableData.' + scope.$index + '.chineseFreightFee'"
                  :rules="scope.row.freightDisabled ? addFormInfo.addFormInfoRules[scope.$index].chineseFreightFee : {}">
                  <el-input v-model="scope.row.chineseFreightFee" size="small" type="number" clearable
                    :disabled="!scope.row.freightDisabled"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="pictureUrl" :label="$t('feedback.feedback9')" width="60">
              <template v-slot="scope">
                <img v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0" :src="scope.row.pictureUrl" alt=""
                  style="width: 50px; height: 50px" />
                <el-upload class="avatar-uploader" v-if="scope.row.pictureUrl.length == 0" action="/" :show-file-list="false"
                  :http-request="uploadImg" accept=".jpg,.png,.jpeg" :limit="1" :before-upload="beforeImgUpload">
                  <el-button class="list-btn btn-blue" ref="uploadImg" @click="beforeUploadImg(scope.$index)">
                    {{ $t('createOrder.createOrder20') }}</el-button>
                </el-upload>
                <el-button v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0" class="list-btn btn-red"
                  @click="delImg(scope.row, scope.$index)">{{ $t('delete') }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="pdfName" :label="$t('createOrder.createOrder22')" width="80">
              <template slot-scope="scope">
                <el-upload v-if="scope.row.pdfName.length == 0" action="/" :http-request="uploadVideo"
                  :before-upload="beforePdfUpload" accept=".pdf,.ai" :limit="1" :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadVideo" @click="beforeUploadVideo(scope.$index)">
                    {{ $t('createOrder.createOrder20') }}</el-button>
                </el-upload>
                <span v-if="scope.row.pdfName">{{ scope.row.pdfName }}</span>
                <el-button v-if="scope.row.pdfName && scope.row.pdfName.length > 0" class="list-btn btn-red"
                  @click="delPdf(scope.row)">{{ $t('delete') }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="agentFlag" :label="$t('createOrder.createOrder99')" width="110">
              <template slot-scope="scope">
                <!-- 代为购买 -->
                <el-form-item class="no-label line-height-30" :prop="'tableData.' + scope.$index + '.agentFlag'">
                  <label>{{ $t('createOrder.createOrder21') }}</label>
                  <el-select @change="agentFlagchange(scope.row.agentFlag, scope.$index,scope.row)" :disabled="agentFlagType"
                    v-model="scope.row.agentFlag" :placeholder="$t('address.address38')" size="small">
                    <el-option v-for="item in agentFlagOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- 包装意向 -->
                <el-form-item class="no-label line-height-30" :prop="'tableData.' + scope.$index + '.putIntent'">
                  <label>{{ $t($t('createOrder.createOrder27')) }}</label>
                  <el-select v-model="scope.row.putIntent" :placeholder="$t('address.address38')" size="small" clearable>
                    <el-option v-for="(item, index) in putIntentOption" :key="index" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="fnsku" :label="$t('createOrder.createOrder23')" width="170">
              <template slot-scope="scope">
                <!-- FBA/YFF/ZOZO/RSL -->
                <el-row>
                  <el-form-item class="no-label line-height-30" :prop="'tableData.' + scope.$index + '.orderType'">
                    <el-select v-model="scope.row.orderType" :placeholder="$t('address.address38')" size="small"
                      @change="orderTypeChange(scope.row.orderType, scope.$index,scope.row)">
                      <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item class="no-label line-height-30" :prop="'tableData.' + scope.$index + '.fnsku'"
                    :rules="scope.row.fnskuDisabled ? addFormInfo.addFormInfoRules[scope.$index].fnsku : {}">
                    <span>{{scope.row.skuLabel?scope.row.skuLabel:'コード'}}</span>
                    <el-input v-model="scope.row.fnsku" :placeholder="scope.row.skuPlaceolder" size="small" clearable
                      :disabled="!scope.row.fnskuDisabled"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item class="no-label line-height-30" :label="$t('createOrder.createOrder113')"
                    :prop="'tableData.' + scope.$index + '.goodsNameCus'"
                    :rules="scope.row.fnskuDisabled ? addFormInfo.addFormInfoRules[scope.$index].goodsNameCus : {}">
                    <el-input maxlength="200" v-model="scope.row.goodsNameCus" size="small" clearable
                      :disabled="!scope.row.fnskuDisabled"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item class="no-label line-height-30" label="ASIN" :prop="'tableData.' + scope.$index + '.asin'"
                    :rules="scope.row.fnskuDisabled ? addFormInfo.addFormInfoRules[scope.$index].asin : {}">
                    <el-input v-model="scope.row.asin" size="small" clearable :disabled="!scope.row.fnskuDisabled"></el-input>
                  </el-form-item>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="configCheckProjectOrigin" :label="$t('createOrder.createOrder25')" min-width="120">
              <template slot-scope="scope">
                <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.configCheckProjectOrigin'" clearable>
                  <el-select multiple v-model="scope.row.configCheckProjectOrigin" :placeholder="$t('address.address38')"
                    size="small" @change="configCheckChanged(scope.row)">
                    <el-option v-for="(item, index) in inspectionOption" :key="index" :label="item.name" :value="item.nameCd">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="inspectionFileName" :label="$t('createOrder.createOrder95')" width="80">
              <template slot-scope="scope">
                <el-upload v-if="scope.row.inspectionFileName.length == 0" action="/" :http-request="uploadFile"
                  :before-upload="beforeFileUpload" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.jpg,.jpeg,.png,.gif"
                  :limit="1" :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadFile" @click="beforeUploadFile(scope.$index)">
                    {{ $t('createOrder.createOrder20') }}</el-button>
                </el-upload>
                <span v-if="scope.row.inspectionFileName">{{ scope.row.inspectionFileName }}</span>
                <el-button v-if="scope.row.inspectionFileName && scope.row.inspectionFileName.length > 0" class="list-btn btn-red"
                  @click="delFile(scope.row)">{{ $t('delete') }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="laundryLabelId" :label="$t('createOrder.createOrder26')" width="120">
              <template slot-scope="scope">
                <el-form-item class="mini-label" :prop="'tableData.' + scope.$index + '.laundryLabelId'" label=' '
                  :rules="scope.row.isTempDisabled ? addFormInfo.addFormInfoRules[scope.$index].laundryLabelId : {}">
                  <el-select v-model="scope.row.laundryLabelId" :placeholder="$t('address.address38')" size="small" clearable
                    :disabled="!scope.row.isTempDisabled">
                    <el-option v-for="item in laundryLabelOption" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="putIntent" :label="$t('createOrder.createOrder27')" width="90">
              <template slot-scope="scope">
                <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.putIntent'">
                  <el-select v-model="scope.row.putIntent" :placeholder="$t('address.address38')" size="small" clearable>
                    <el-option v-for="(item,index) in putIntentOption" :key="index" :label="item.name"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column> -->
            <!--<el-table-column :label="$t('createOrder.createOrder28')" min-width="230">
							<template slot-scope="scope">
								<el-form-item :label="$t('createOrder.createOrder29')">
									{{ scope.row.sender }}
								</el-form-item>
								<el-form-item :label="$t('createOrder.createOrder30')">
									{{ scope.row.senderPhone }}
								</el-form-item>
								<el-form-item :label="$t('createOrder.createOrder35')">
									{{ scope.row.senderzipCode }}
								</el-form-item>
								发货人地址
								<el-form-item :label="$t('createOrder.createOrder31')">
									{{ scope.row.sendAddress }}
								</el-form-item>
								<el-form-item>
									<el-button @click="changeaddress(0, 1, scope.$index)" class="list-btn btn-blue">{{ $t('createOrder.createOrder32') }}</el-button>
									<el-button @click="addaddress(2, scope.row, scope.$index)" data-index="2" class="list-btn btn-blue">{{ $t('createOrder.createOrder33') }}</el-button>
								</el-form-item>
							</template>
						</el-table-column>-->
            <!-- el-table-column :label="$t('createOrder.createOrder34')" min-width="230">
							<template slot-scope="scope">
								<el-form-item :label="$t('createOrder.createOrder29')">
									{{ scope.row.receiver }}
								</el-form-item>
								<el-form-item :label="$t('createOrder.createOrder30')">
									{{ scope.row.receiverPhone }}
								</el-form-item>
								<el-form-item :label="$t('createOrder.createOrder35')">
									{{ scope.row.receiverzipCode }}
								</el-form-item>
								 收货人地址
								<el-form-item :label="$t('createOrder.createOrder31')">
									{{ scope.row.receiverAddress }}
								</el-form-item>
								<el-form-item>
									<el-button @click="changeaddress(0, 0, scope.$index)" class="list-btn btn-blue">{{ $t('createOrder.createOrder32') }}</el-button>
									<el-button @click="addaddress(1, scope.row, scope.$index)" data-index="1" class="list-btn btn-blue">{{ $t('createOrder.createOrder33') }}</el-button>
								</el-form-item>
							</template>
						</el-table-column> -->
            <el-table-column prop="customerRemark" :label="$t('createOrder.createOrder111')" width="80">
              <template slot-scope="scope">
                <el-form-item class="no-label" :prop="'tableData.' + scope.$index + '.customerRemark'">
                  <el-input v-model="scope.row.customerRemark" size="small" type="textarea" :rows="5"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>

          <el-row class="addOrder-btn-container">
            <el-col :span="20">
              <el-button @click="addOrder" class="form-btn btn-green">+ {{ $t('createOrder.createOrder36') }}</el-button>
            </el-col>
            <el-col :span="4">
              <el-button @click="cancelForm" class="form-btn btn-gray">{{ $t('cancel') }}</el-button>
              <el-button @click="saveForm" class="form-btn btn-blue">{{ $t('submit') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </full-con>
    <!--商品详情 -->
    <!-- <el-dialog :title="$t('menu.menu5')" :visible.sync="goodsDialogVisible" width="80%" @close="goodsDialogVisible=false"> -->
    <el-dialog :title="$t('menu.menu5')" :visible.sync="goodsDialogVisible" width="80%" @close="goodsDialog">
      <div class="product-detail">
        <div class="intro-container overflow">
          <div class="picture-container left">
            <div class="top-img">
              <!-- <div v-if="isInSmImg == '1'" >
                  <div v-for="(item,index) in imgUrls" :key="index">
                    <div  class="lg-img" v-if="item.select==1">
                      <img :src="item.url" alt="">
                    </div>
                  </div>
              </div> -->
              <div class="lg-img">
                <img v-if="SelectedAttrImgUrl.length > 0" :src="SelectedAttrImgUrl" alt="" />
                <img v-else src="../../../assets/images/default.png" alt="" />
              </div>
            </div>
            <!-- <div class="bottom-img">
                <div :class="item.select==1?'sm-img sm-img-selected':'sm-img'" v-for="(item,index) in imgUrls" :key="index">
                    <img v-if="index<6" :src="item.url" alt="" @click="smImgClick(item)">
                </div>
            </div> -->
          </div>
          <div class="attr-container left">
            <el-form label-width="66px" ref="productDetailForm" :model="productForm">
              <div class="name-container">
                {{ productName }}
              </div>
              <div class="price-container">
                <el-form-item :label="$t('createOrder.createOrder37')">
                  <el-input size="small" v-model="productForm.skuPrice"></el-input>
                </el-form-item>
              </div>
              <div class="specification-container">
                <div class="attr-row overflow" v-for="(item, index) in specificationList" :key="index">
                  <div class="title left" style="height: 30px; line-height: 30px">{{ item.name }}:</div>
                  <div :class="item2.checked == '1' ? 'attr-tag left attr-tag-checked' : 'attr-tag left attr-tag'"
                    v-for="(item2, index2) in item.value" @click="tagClick(item2, item)" :key="index2">
                    {{ item2.name }}
                  </div>
                </div>
              </div>
              <div class="stock-container">
                <el-form-item :label="$t('createOrder.createOrder38')">
                  <el-input-number controls-position="right" :min="0" v-model="productForm.quantity" size="small"
                    onkeyup="this.value.replace(/\|D^0/g,'')"> </el-input-number>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="detail-container"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="goodsCancel">{{ $t('cancel') }}</el-button>
        <el-button class="form-btn btn-blue" @click="goodsSave">{{ $t('confirm') }}</el-button>
      </span>
    </el-dialog>
    <!--地址选择 -->
    <el-dialog :title="addresstit" :visible.sync="addVisible" width="40%" ref="addchange" @close="addCancel">
      <el-row style="width: 90%; margin: 0 auto 20px" class="search-row">
        <el-col :span="6" class="display-row">
          <el-input :placeholder="$t('createOrder.createOrder29')" clearable v-model="addsearch.receiverName" size="small">
          </el-input>
        </el-col>
        <el-col :span="18" class="display-row">
          <div class="search-btn-container">
            <el-button class="search-btn btn-gray" @click="addClear">{{ $t('reset') }}</el-button>
            <el-button class="search-btn btn-blue" @click="searchList()">{{ $t('query') }}</el-button>
          </div>
        </el-col>
      </el-row>
      <div style="height: 500px; overflow-y: auto">
        <div class="address" @click="selectadd(index, item)" :class="{ active: changeadd == index }"
          v-for="(item, index) in addressList" :key="index">
          <p style="margin-left: 20px; margin-top: 20px">
            <font color="#d5d3d3">{{ $t('createOrder.createOrder29') }}</font>
            <span style="margin-left: 60px">{{ item.receiverName }}</span>
            <span v-if="item.defaultAddress == 1"
              style="float: right; margin-right: 30px; color: #a8caee">{{ $t('createOrder.createOrder39') }}</span>
          </p>
          <p style="margin-left: 20px; margin-top: 20px">
            <font color="#d5d3d3">{{ $t('address.address4') }}</font>
            <span style="margin-left: 60px">{{ item.receiverPhone }}</span>
          </p>
          <p style="margin-left: 20px; margin-top: 20px">
            <font color="#d5d3d3">{{ $t('address.address9') }}</font>
            <span style="margin-left: 60px">{{ item.provenceName }}{{ item.cityName }}{{ item.areaName }}</span>
            <span style="margin: 0 30px">-</span>
            <span>{{ item.addressInfo }}</span>
          </p>
          <p style="margin-left: 20px; margin-top: 20px">
            <font color="#d5d3d3">{{ $t('address.address20') }}</font>
            <span style="margin-left: 60px">{{ item.postcode }}</span>
          </p>
          <p style="margin-left: 20px; margin-top: 20px; margin-bottom: 30px">
            <font color="#d5d3d3">{{ $t('goods.goods48') }}</font>
            <span style="margin-left: 60px">{{ item.notes }}</span>
          </p>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="addsearch.pageNum"
        :page-sizes="[5, 10, 20, 50, 100]" :page-size="addsearch.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="addsearch.total"></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="addaddress(0)">{{ $t('address.address15') }}</el-button>
        <el-button class="form-btn btn-gray" @click="addCancel">{{ $t('cancel') }}</el-button>
        <el-button class="form-btn btn-blue" @click="addSave()">{{ $t('submit') }}</el-button>
      </span>
    </el-dialog>

    <!--    新建修改地址-->
    <el-dialog :title="addtitle" :visible.sync="dialogVisibleaddress" width="40%" @close="handleClose">
      <el-form label-position="left" ref="add_address" :rules="addrules" :inline="true" :model="add_addressList"
        class="demo-form-inline">
        <el-form-item style="width: 48%" prop="receiveName">
          <el-input v-model="add_addressList.receiveName" style="width: 100%" :placeholder="$t('address.address19')"></el-input>
        </el-form-item>
        <el-form-item style="width: 48%" prop="phoneNumber">
          <el-input v-model="add_addressList.phoneNumber" :placeholder="$t('createOrder.createOrder40')"></el-input>
        </el-form-item>
        <el-form-item label="" style="width: 100% !important" prop="add_addressList">
          <el-cascader style="width: 100%" size="large" :placeholder="$t('createOrder.createOrder41')"
            v-model="add_addressList.address" :options="options" :props="defaultParams" ref="cascaderAddr" @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item style="width: 100% !important" prop="detailedAddress">
          <el-input v-model="add_addressList.detailedAddress" :placeholder="$t('address.address25')"></el-input>
        </el-form-item>
        <el-form-item prop="note">
          <el-input v-model="add_addressList.note" :placeholder="$t('createOrder.createOrder42')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('createOrder.createOrder43')" style="display: block">
          <!--          <el-switch    v-model=""></el-switch>-->
          <el-switch v-model="value"></el-switch>
        </el-form-item>

        <el-form-item style="text-align: center; width: 100% !important">
          <el-button type="primary " class="form-btn btn-blue" @click="addsubmit">{{ $t('confirm') }}</el-button>
          <el-button type="primary " class="form-btn btn-gray" @click="addcancle">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('createOrder.createOrder101')" :visible.sync="openDialog" width="600px" @close="openDialog=false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item style="margin-bottom:0px" :label="$t('createOrder.createOrder102')">
          {{userName}}
        </el-form-item>
        <el-form-item style="margin-bottom:0px" :label="$t('createOrder.createOrder103')">
          {{ $t('createOrder.createOrder110') }}
        </el-form-item>
        <el-form-item style="margin-bottom:10px" :label="$t('createOrder.createOrder104')">

        </el-form-item>
        <el-form-item style="margin-bottom:30px" :label="$t('createOrder.createOrder105')" prop="remindingTitle">
          <el-input v-model="ruleForm.remindingTitle" maxlength="100" :placeholder="$t('createOrder.createOrder108')"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom:30px" :label="$t('createOrder.createOrder106')" prop="remindingContent">
          <el-input type="textarea" :rows="2" :placeholder="$t('createOrder.createOrder109')" v-model="ruleForm.remindingContent">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('createOrder.createOrder107')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}"
            action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="true"
            :file-list="ruleForm.replyPicture" :show-file-list="true" list-type="picture-card" :on-remove="handleImgRemove"
            :on-success="handleImgSuccess" :before-upload="beforeImgUpload1" :limit="3">
            <el-button size="small" type="primary">{{$t('saledFeedback.clickUpload')}}</el-button>
          </el-upload>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}" action="" :on-preview="handlePreview1"
            :on-remove="handleRemove" :before-upload="beforeUploadFile1" :before-remove="beforeRemove1"
            :on-success="handleOrderInfo1" :multiple="true" :show-file-list="true" :limit="3" :on-exceed="handleExceed1"
            :file-list="fileList1" :http-request="excelUploadRequest1">
            <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button @click="openDialog=false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('loginR.login32') }}</el-button>

        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import func from 'vue-editor-bridge';
import Oss from '../../../assets/js/oss.js';
// import Utils from '../../../assets/js/utils.js'
import lodash from 'lodash';
import { isvalidPhone } from '../../../assets/js/validate';

const checkPhone = (rule, value, callback) => {
  if (isvalidPhone(value)) {
    callback();
  } else {
    callback(new Error(this.$t('createOrder.createOrder44')));
  }
};
const checkNone = (rule, value, callback) => {
  callback();
};

export default {
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data () {
    return {
      fileList1: [],
      userName: sessionStorage.getItem("username"),
      ruleForm: {
        remindingTitle: '',
        remindingContent: ''
      },
      rules: {
        remindingTitle: [
          { required: true, message: this.$t('createOrder.createOrder108'), trigger: 'blur' },
        ],
        remindingContent: [
          { required: true, message: this.$t('createOrder.createOrder109'), trigger: 'blur' },
        ],
      },
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      flag: false,
      typeNum: '',
      newArr: [],
      openDialog: false,
      echo: [],
      isDisabled: true,
      defaultParams: {
        label: 'text',
        value: 'id',
        children: 'children',
        expandTrigger: 'click',
        checkStrictly: false
      },
      randomKey: Math.random(),
      options: [],
      agentFlagType: false,
      value: true,
      formInline: {
        outWarehouseId: '',
        inWarehouseId: '',
        logisticsCompanyId: '',
        waybillNumber: '',
        additionalServices: '',
        remarks: '',
        sendType: 0,
        date: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        orderOutboundDetailList: [
          {
            goodsTypeId: [],
            goodsName: '',
            goodsSpecification: '',
            goodsCount: '',
            price: '',
            remarks: '',
            skuNo: ' '
          }
        ],
        formInlinerules: [
          {
            goodsName: [
              {
                required: true,
                message: this.$t('createOrder.createOrder45'),
                trigger: 'blur'
              }
            ],
            goodsSpecification: [
              {
                required: true,
                message: this.$t('createOrder.createOrder46'),
                trigger: 'blur'
              }
            ],
            goodsCount: [
              {
                required: true,
                message: this.$t('createOrder.createOrder47'),
                trigger: 'blur'
              },
              {
                pattern: /^[1-9]\d*$/,
                message: this.$t('createOrder.createOrder48'),
                trigger: 'blur'
              }
            ],
            price: [
              {
                pattern: /(^(([1-9]([0-9]+)?)|(0{1}))(\.[0-9]{1,2})?$)/,
                message: this.$t('createOrder.createOrder49'),
                trigger: 'blur'
              }
            ],
            remarks: [
              {
                required: true,
                message: this.$t('createOrder.createOrder50'),
                trigger: 'blur'
              }
            ]
          }
        ]
      },
      placeholders: {
        province: this.$t('createOrder.createOrder51'),
        city: this.$t('createOrder.createOrder52'),
        area: this.$t('createOrder.createOrder53')
      },
      addtitle: '',
      add_addressList: {
        receiveName: '',
        phoneNumber: '',
        province: '',
        city: '',
        area: '',
        detailedAddress: '',
        note: '',
        country: ''
      },
      addrules: {
        receiveName: [{ required: true, message: this.$t('createOrder.createOrder54'), trigger: 'blur' }],
        phoneNumber: [{ required: true, message: this.$t('createOrder.createOrder55'), trigger: 'blur' }],
        detailedAddress: [
          {
            required: true,
            message: this.$t('createOrder.createOrder56'),
            trigger: 'blur'
          }
        ],
        note: [
          {
            required: true,
            message: this.$t('createOrder.createOrder57'),
            trigger: 'blur'
          }
        ]
      },
      type: 0,
      dialogVisibleaddress: false,
      hideUploadEdit: false,
      item: '',
      changeadd: 0,
      // disabled:false,
      reivedisabled: false,
      senderdisabled: false,
      addressList: [],
      addsearch: {
        receiverName: '',
        type: '',
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      addVisible: false,
      addresstit: '',
      //图片、pdf上传
      imgDialogVisible: false,
      listObj: {},
      imgFileList: [],
      fileList: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      curRow: 0,
      curRowPDF: 0,
      curRowImg: 0,
      curRowFile: 0,
      curUploadImgArr: [],

      pdfDialogVisible: false,
      pdfFileList: [],
      pdfDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      fileDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      curUploadPdfArr: [],
      pdfListObj: {},
      fileListObj: {},
      addFormInfo: {
        tableData: [],
        addFormInfoRules: []
      },
      idx: 0, // 数组下标
      // concatStr: '',
      categoryFlagOption: [
        {
          label: this.$t('running.suspended1'),
          value: '1'
        },
        {
          label: this.$t('running.suspended0'),
          value: '0'
        }
      ],
      agentFlagOption: [
        {
          label: this.$t('running.suspended1'),
          value: '1'
        },
        {
          label: this.$t('running.suspended0'),
          value: '0'
        }
      ],
      agentFlagState: null, // 管理端设置是否为代为购买
      // configLists:[],
      fbaOption: [
        {
          label: this.$t('running.suspended0'),
          value: '1'
        },
        {
          label: 'FBA',
          value: '0'
        },
        {
          label: 'YFF',
          value: '2'
        },
        {
          label: 'ZOZO',
          value: '3'
        },
        {
          label: 'RSL',
          value: '4'
        },
      ],
      inspectionOption: [],
      laundryLabelOption: [],
      senderLis: {},
      receiverLis: {},
      // concatStr1:'',
      userInfo: {
        balance: '',
        paperLabelCount: '',
        signCount: '',
        washingMark: '',
        accessoriesCount: '',
        hotboomFlag: ''
      },
      goodsDialogVisible: false,

      // 商品详情
      productName: '',
      //规格
      specificationList: [],
      /*左侧显示图片数组*/
      // imgUrls:[],
      isInSmImg: 1,
      index: 0,
      /*右侧属性选中后显示的img*/
      SelectedAttrImgUrl: '',
      selectedAttr: [],
      /*商品sku表*/
      productArray: [],
      productForm: {
        skuPrice: '',
        quantity: '1'
      },
      editCurRow: '',
      selectedSku: {},
      pullSize: '',
      pullName: '',
      objTemp: {
        sendAddress: '',
        receiverAddress: ''
      },
      putIntentOption: [
        {
          name: this.$t('createOrder.createOrder58'),
          value: '0'
        },
        {
          name: this.$t('createOrder.createOrder59'),
          value: '1'
        },
        {
          name: this.$t('createOrder.createOrder60'),
          value: '2'
        },
        {
          name: this.$t('createOrder.createOrder61'),
          value: '3'
        }
      ],
      exportNum: 1
    };
  },
  methods: {
    handleRemove1 () {
      this.ruleForm.fileName = ''
      this.ruleForm.filePath = ''
    },
    handlePreview1 () {
      // console.log(file);
    },
    handleExceed1 (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')}，${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')}，${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      );
    },
    beforeUploadFile1 (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.'))
      console.log(extension)
      // const size = file.size / 1024 / 1024
      if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf') {
        this.$message.warning('只能上传excel和pdf文件')
        return false
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    // 批量导入
    async excelUploadRequest1 (file) {
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        let {fileName,filePath} = res.data;
        this.fileList1.push({name:fileName,url:filePath})
      }
    },
    beforeRemove1 () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    // 批量导入成功回调
    handleOrderInfo1 () {
      console.log('success')
      // console.log(data)
    },
    async submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const arr = Object.keys(this.listObj).map(v => this.listObj[v]);
          let urlArr = []
          arr.forEach(el => {
            urlArr.push(el.url);
          })
          if (arr.length > 0) {
            this.ruleForm.replyPicture = urlArr.join(',')
          } else {
            this.ruleForm.replyPicture = ''
          }

          if (this.fileList1.length>0){
            this.ruleForm.attachment = JSON.stringify(this.fileList1);
          }else{
            this.ruleForm.attachment = ''
          }

          this.ruleForm.messageType = 2
          let data = this.ruleForm

          const { data: res } = await this.$http.post('cmUser/message/sendMessage', data);

          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.openDialog = false
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }


        } else {

          return false;
        }
      });
    },
    handleImgRemove (file) {
      Oss.imgRemove(file, this.listObj);
      this.hideUploadEdit = false
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
      this.hideUploadEdit = true
    },
    beforeImgUpload1 (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/bad/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/bad';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          file.timeStamp = num
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(false)
        })
      })
    },
    // 拉取得商品详情关闭弹框回调
    goodsDialog () {
      this.productForm.skuPrice = '';
      this.$set(this.productForm, 'quantity', '1');
      if (this.selectedSku.properties_name) {
        this.selectedSku.properties_name = []
      }
      this.specificationList = ''
      this.flag = false
    },
    handleClose () {
      for (const key in this.add_addressList) {
        this.add_addressList[key] = '';
      }
      // this.SelectDefaultAddress();
    },
    handleChange (value) {
      // console.log(value)
      this.add_addressList.province = value[0];
      this.add_addressList.city = value[1];
      this.add_addressList.area = value[2];
      let nodeContent = this.$refs['cascaderAddr'].getCheckedNodes();
      this.$nextTick(() => {
        let casename = this.$refs['cascaderAddr'].presentText.split(this.$refs['cascaderAddr'].separator);
        if (this.typeNum == 2) {
          this.objTemp.sendAddress = casename[0] + casename[1] + casename[2];
          // this.newArr[this.idx].sendAddress = casename[0]+casename[1]+casename[2]
          // this.concatStr = casename[0]+casename[1]+casename[2]
        } else if (this.typeNum == 1) {
          this.objTemp.receiverAddress = casename[0] + casename[1] + casename[2];
          // this.concatStr1 = casename[0]+casename[1]+casename[2]
          // this.newArr[this.idx].receiverAddress = casename[0]+casename[1]+casename[2]
        }
        // console.log('this.idx',this.idx)
        this.newArr[this.idx] = this._.cloneDeep(this.objTemp);
        // this.add_addressList.detailedAddress = casename[0]+casename[1]+casename[2]+
        // console.log("value：", casename);
      });
    },
    getTreeData (data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].levelType !== '4') {
          if (data[i].children.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].children = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        } else {
          continue;
        }
      }
      return data;
    },
    async getAddressList_rp () {
      //获取地址列表
      let url = 'cms/configAccountNumber/getAddressList';
      const { data: res } = await this.$http.get(url);
      this.options = this.getTreeData(res.data);
    },
    agentFlagchange (type, index, row) {
      if (type == 1) {
        this.addFormInfo.addFormInfoRules[index].trackingNumberCn = [
          {
            required: false,
            message: this.$t('createOrder.createOrder62'),
            trigger: 'blur'
          }
        ];
        this.addFormInfo.tableData[index].trackingNumberCnType = false;
        row.chineseFreightFee = 0;
        this.$set(row, 'freightDisabled', true);
        this.addFormInfo.addFormInfoRules[index].chineseFreightFee[0].required = true;
      } else {
        this.addFormInfo.addFormInfoRules[index].trackingNumberCn = [
          {
            required: true,
            message: this.$t('createOrder.createOrder62'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: this.$t('createOrder.createOrder63'),
            trigger: 'blur'
          }
        ];
        this.addFormInfo.tableData[index].trackingNumberCnType = true;
        row.chineseFreightFee = '';
        this.$set(row, 'freightDisabled', false);
        //this.addFormInfo.addFormInfoRules[index].chineseFreightFee[0].required = false;
      }
      this.addFormInfo.tableData[0].trackingNumberCnType = !this.addFormInfo.addFormInfo[0].trackingNumberCnType;
    },
    //保存
    addsubmit () {
      var _this = this;
      this.$refs.add_address.validate(function (valid) {
        if (valid) {
          var su;
          _this.value ? (su = '1') : (su = '0');
          if (_this.add_addressList.province === '') {
            _this.$message.error(this.$t('createOrder.createOrder64'));
          } else {
            if (_this.add_addressList.id) {
              _this.$http
                .post('cms/configAddressInfo/insertAndEdit', {
                  id: _this.add_addressList.id,
                  type: _this.type,
                  receiverName: _this.add_addressList.receiveName,
                  receiverPhone: _this.add_addressList.phoneNumber,
                  provence: _this.add_addressList.province,
                  city: _this.add_addressList.city,
                  postcode: _this.add_addressList.note,
                  area: _this.add_addressList.area,
                  addressInfo: _this._.cloneDeep(_this.add_addressList.detailedAddress),
                  // notes:this.add_addressList.id,
                  defaultAddress: su
                  // addressNo:this.add_addressList.addressNo,
                })
                .then((res) => {
                  if (res.data.code === 200) {
                    // console.log(_this.type+"=====_this.type===")
                    _this.randomKey = Math.random();
                    if (_this.type == 0) {
                      _this.addFormInfo.tableData[_this.index].receiver = _this.add_addressList.receiveName;
                      _this.addFormInfo.tableData[_this.index].receiverPhone = _this.add_addressList.phoneNumber;
                      _this.addFormInfo.tableData[_this.index].receiverAddress = _this._.cloneDeep(_this.add_addressList.detailedAddress);
                      _this.addFormInfo.tableData[_this.index].receiverdefaultAddress = _this.add_addressList.defaultAddress;
                      // this.addFormInfo.tableDa_ta[this.index].addressNo=res.addressNo
                      _this.addFormInfo.tableData[_this.index].receiverid = _this.add_addressList.id;
                      // _this.addFormInfo.tableData[
                      //     _this.index
                      //     ].receiverCode =
                      //     _this.add_addressList.province;
                      _this.addFormInfo.tableData[_this.index].receiverCode = _this.receiverCode;
                      _this.addFormInfo.tableData[_this.index].receiverzipCode = _this.add_addressList.note;
                      _this.addFormInfo.tableData[_this.index].receiverprovence = _this.add_addressList.province;
                      _this.addFormInfo.tableData[_this.index].receiverarea = _this.add_addressList.area;
                      _this.addFormInfo.tableData[_this.index].receivercity = _this.add_addressList.city;
                    } else {
                      // console.log('_this.add_addressList',_this.add_addressList)
                      _this.addFormInfo.tableData[_this.index].sender = _this.add_addressList.receiveName;
                      _this.addFormInfo.tableData[_this.index].senderPhone = _this.add_addressList.phoneNumber;
                      _this.addFormInfo.tableData[_this.index].sendAddress = _this._.cloneDeep(_this.add_addressList.detailedAddress);
                      _this.addFormInfo.tableData[_this.index].senderdefaultAddress = res.defaultAddress;
                      _this.addFormInfo.tableData[_this.index].senderid = _this.add_addressList.id;
                      // _this.addFormInfo.tableData[
                      //     _this.index
                      //     ].senderCode =
                      //     _this.add_addressList.province;
                      _this.addFormInfo.tableData[_this.index].senderCode = _this.senderCode;
                      _this.addFormInfo.tableData[_this.index].senderzipCode = _this.add_addressList.note;
                      _this.addFormInfo.tableData[_this.index].senderprovence = _this.add_addressList.province;
                      _this.addFormInfo.tableData[_this.index].senderarea = _this.add_addressList.area;
                      _this.addFormInfo.tableData[_this.index].sendercity = _this.add_addressList.city;
                    }

                    _this.$message.success(_this.$t('success'));
                    _this.dialogVisibleaddress = false;

                    _this.$set(_this.addFormInfo.tableData, _this.index, _this.addFormInfo.tableData[_this.index]);
                  } else {
                    _this.$message.error(res.data.message);
                  }
                });
            } else {
              _this.$http
                .post('cms/configAddressInfo/insertAndEdit', {
                  type: _this.type,
                  receiverName: _this.add_addressList.receiveName,
                  receiverPhone: _this.add_addressList.phoneNumber,
                  provence: _this.add_addressList.province,
                  city: _this.add_addressList.city,
                  postcode: _this.add_addressList.note,
                  area: _this.add_addressList.area,
                  addressInfo: _this._.cloneDeep(_this.add_addressList.detailedAddress),
                  // notes:this.add_addressList.id,
                  defaultAddress: su
                  // addressNo:1
                })
                .then((res) => {
                  if (res.data.code === 200) {
                    _this.$message.success(_this.$t('success'));
                    _this.dialogVisibleaddress = false;
                    _this.searchList();
                    _this.randomKey = Math.random();
                    _this.$set(_this.addFormInfo.tableData, _this.index, _this.addFormInfo.tableData[_this.index]);
                  } else {
                    _this.$message.error(res.data.message);
                  }
                });
            }
          }
        }
      });
    },
    handleOpenDialog () {
      this.openDialog = true
      this.fileList1 = []
      this.ruleForm.fileName = ''
      this.ruleForm.remindingTitle = ''
      this.ruleForm.remindingContent = ''
      this.ruleForm.replyPicture = []
      this.ruleForm.filePath = ''
      this.ruleForm.attachment = ''
      this.listObj = []
      this.hideUploadEdit = false
    },
    change (type) {
      // console.log(type);
    },
    addcancle () {
      this.dialogVisibleaddress = false;
    },
    onSelected (data) {
      // alert(data.province.value + ' | ' + data.city.value + ' | ' + data.area.value)
      this.add_addressList.province = data.province.value;
      this.add_addressList.city = data.city.value;
      this.add_addressList.area = data.area.value;
    },
    // 编辑
    addaddress (type, row, index) {
      this.typeNum = type;
      this.idx = index;
      // 1收件人编辑2发件人编辑0新增
      if (index) {
        this.index = index;
      }
      if (type === 2) {
        if (!row.senderCode) {
          this.$message(this.$t('createOrder.createOrder65'));
          return;
        }
        this.type = 1;
        this.addtitle = this.$t('address.address14');
        this.add_addressList.receiveName = row.sender;
        this.add_addressList.phoneNumber = row.senderPhone;
        this.add_addressList.detailedAddress = this._.cloneDeep(row.sendAddress);
        this.add_addressList.note = row.sendernote;
        this.add_addressList.province = row.senderprovence;
        this.add_addressList.city = row.sendercity;
        this.add_addressList.area = row.senderarea;
        this.add_addressList.address = [parseInt(row.senderprovence), parseInt(row.sendercity), parseInt(row.senderarea)];
        this.add_addressList.id = row.senderid;
        this.add_addressList.note = row.senderzipCode;

        // this.add_addressList.addressNo=row.addressNo
        if (row.senderdefaultAddress == 1) {
          this.value = true;
        } else {
          this.value = false;
        }
        this.add_addressList.defaultAddress = row.senderdefaultAddress;
      } else if (type === 1) {
        // console.log('sssdss',row)
        if (!row.receiverCode) {
          this.$message(this.$t('createOrder.createOrder66'));
          return;
        }
        this.type = 0;
        this.addtitle = this.$t('address.address14');
        this.add_addressList.receiveName = row.receiver;
        this.add_addressList.phoneNumber = row.receiverPhone;
        this.add_addressList.detailedAddress = this._.cloneDeep(row.receiverAddress);
        this.add_addressList.note = row.receivernote;
        this.add_addressList.province = row.receiverprovence;
        this.add_addressList.city = row.receivercity;
        this.add_addressList.area = row.receiverarea;
        this.add_addressList.address = [parseInt(row.receiverprovence), parseInt(row.receivercity), parseInt(row.receiverarea)];
        this.add_addressList.defaultAddress = row.receiverdefaultAddress;
        this.add_addressList.id = row.receiverid;
        this.add_addressList.note = row.receiverzipCode;
        // this.add_addressList.addressNo=row.addressNo
        // console.log(this.add_addressList);
        if (row.receiverdefaultAddress == 1) {
          this.value = true;
        } else {
          this.value = false;
        }
      } else {
        this.addtitle = this.$t('address.address15');
      }
      this.dialogVisibleaddress = true;
    },
    selectadd (index, item) {
      this.changeadd = index;
      this.item = item;
    },
    //选择地址，提交
    addSave () {
      // type0-收件地址 1-发货地址
      let item = this._.cloneDeep(this.item);
      // console.log('ittem',item)
      // this.addFormInfo.tableData[this.index].receiverprovence =
      //         item.provence;
      //     this.addFormInfo.tableData[this.index].receivercity =
      //         item.city;
      //     this.addFormInfo.tableData[this.index].receiverarea =
      //         item.area;
      // console.log('this.index',this.index)
      if (this.item !== '') {
        if (this.addsearch.type === 0) {
          this.objTemp.receiverAddress = item.provenceName + item.cityName + item.areaName;
          this.newArr[this.index] = this._.cloneDeep(this.objTemp);
          this.reivedisabled = false;
          this.addFormInfo.tableData[this.index].receiver = item.receiverName;
          this.addFormInfo.tableData[this.index].receiverPhone = item.receiverPhone;
          this.addFormInfo.tableData[this.index].receiverzipCode = item.postcode;
          let receiverAddress = item.addressInfo;
          this.addFormInfo.tableData[this.index].receiverAddress = this._.cloneDeep(receiverAddress);
          this.addFormInfo.tableData[this.index].receiverdefaultAddress = item.defaultAddress;
          // this.addFormInfo.tableData[this.index].addressNo=item.addressNo
          this.addFormInfo.tableData[this.index].receiverid = item.id;
          // 地址码
          this.addFormInfo.tableData[this.index].receiverprovence = item.provence;
          this.addFormInfo.tableData[this.index].receivercity = item.city;
          this.addFormInfo.tableData[this.index].receiverarea = item.area;
          // 地址字
          this.addFormInfo.tableData[this.index].rprovence = item.provenceName;
          this.addFormInfo.tableData[this.index].rcity = item.cityName;
          this.addFormInfo.tableData[this.index].rarea = item.areaName;
          this.addFormInfo.tableData[this.index].receivernote = item.postcode;
          this.addFormInfo.tableData[this.index].receiverCode = item.addressNo;
          this.receiverCode = item.addressNo;
        } else {
          this.objTemp.sendAddress = item.provenceName + item.cityName + item.areaName;
          this.newArr[this.index] = this._.cloneDeep(this.objTemp);
          this.senderdisabled = false;
          this.addFormInfo.tableData[this.index].sender = item.receiverName;
          this.addFormInfo.tableData[this.index].senderPhone = item.receiverPhone;
          let sendAddress = item.addressInfo;
          this.addFormInfo.tableData[this.index].sendAddress = this._.cloneDeep(sendAddress);
          this.addFormInfo.tableData[this.index].senderdefaultAddress = item.defaultAddress;
          this.addFormInfo.tableData[this.index].senderid = item.id;
          // 地址码
          this.addFormInfo.tableData[this.index].senderprovence = item.provence;
          this.addFormInfo.tableData[this.index].sendercity = item.city;
          this.addFormInfo.tableData[this.index].senderarea = item.area;
          // 地址字
          this.addFormInfo.tableData[this.index].sprovence = item.provenceName;
          this.addFormInfo.tableData[this.index].scity = item.cityName;
          this.addFormInfo.tableData[this.index].sarea = item.areaName;
          this.addFormInfo.tableData[this.index].sendernote = item.postcode;
          this.addFormInfo.tableData[this.index].senderCode = item.addressNo;
          this.addFormInfo.tableData[this.index].senderzipCode = item.postcode;
          // this.addFormInfo.tableData[this.index].senderprovence =
          //     item.provenceName;
          // this.addFormInfo.tableData[this.index].sendercity =
          //     item.cityName;
          // this.addFormInfo.tableData[this.index].senderarea =
          //     item.areaName;
        }
        this.item = '';
        // this.$forceUpdate();
        // let obj =  this.addFormInfo.tableData[this.index]
        // this.$set(
        //     this.addFormInfo.tableData,
        //     this.index,
        //     obj
        // );
        //没有值
      } else {
        this.addressList.map((res) => {
          //如果为默认地址
          if (res.defaultAddress == 1) {
            //为收件人
            if (this.addsearch.type === 0) {
              this.objTemp.receiverAddress = item.provenceName + item.cityName + item.areaName;
              this.newArr[this.index] = this._.cloneDeep(this.objTemp);
              this.reivedisabled = false;
              this.addFormInfo.tableData[this.index].receiver = res.receiverName;
              this.addFormInfo.tableData[this.index].receiverPhone = res.receiverPhone;
              this.addFormInfo.tableData[this.index].zipCode = res.postcode;
              this.addFormInfo.tableData[this.index].receiverAddress = res.addressInfo;
              this.addFormInfo.tableData[this.index].receiverdefaultAddress = res.defaultAddress;
              // this.addFormInfo.tableData[this.index].addressNo=res.addressNo
              this.addFormInfo.tableData[this.index].receiverid = res.id;
              this.addFormInfo.tableData[this.index].receiverCode = res.addressNo;
              this.receiverCode = res.addressNo;
              // 地址码
              this.addFormInfo.tableData[this.index].receivercity = res.city;
              this.addFormInfo.tableData[this.index].receiverarea = res.area;
              this.addFormInfo.tableData[this.index].receiverprovence = res.provence;
              // 地址字
              this.addFormInfo.tableData[this.index].rcity = res.cityName;
              this.addFormInfo.tableData[this.index].rarea = res.areaName;
              this.addFormInfo.tableData[this.index].rprovence = res.provenceName;
              this.addFormInfo.tableData[this.index].receiverzipCode = res.postcode;
              //发件人
            } else {
              this.objTemp.sendAddress = item.provenceName + item.cityName + item.areaName;
              this.newArr[this.index] = this._.cloneDeep(this.objTemp);
              this.senderdisabled = false;
              this.addFormInfo.tableData[this.index].sender = res.receiverName;
              this.addFormInfo.tableData[this.index].senderPhone = res.receiverPhone;
              this.addFormInfo.tableData[this.index].sendAddress = res.addressInfo;
              this.addFormInfo.tableData[this.index].senderdefaultAddress = res.defaultAddress;
              this.addFormInfo.tableData[this.index].senderid = res.id;
              this.addFormInfo.tableData[this.index].senderCode = res.addressNo;
              this.senderCode = res.addressNo;
              // 地址码
              this.addFormInfo.tableData[this.index].sendercity = res.city;
              this.addFormInfo.tableData[this.index].senderarea = res.area;
              this.addFormInfo.tableData[this.index].senderprovence = res.provence;
              // 地址字
              this.addFormInfo.tableData[this.index].scity = res.cityName;
              this.addFormInfo.tableData[this.index].sarea = res.areaName;
              this.addFormInfo.tableData[this.index].sprovence = res.provenceName;
              this.addFormInfo.tableData[this.index].senderzipCode = res.postcode;
            }
            //不是默认地址
          } else {
            //收件人
            if (this.addsearch.type === 0) {
              this.reivedisabled = false;
              this.addFormInfo.tableData[0].receiver = this.addressList[0].receiverName;
              this.addFormInfo.tableData[0].receiverPhone = this.addressList[0].receiverPhone;
              // this.addFormInfo.tableData[0].zipCode=this.addressList[0].postcode
              this.addFormInfo.tableData[0].receiverAddress = this.addressList[0].addressInfo;
              this.addFormInfo.tableData[0].receiverdefaultAddress = this.addressList[0].defaultAddress;
              // this.addFormInfo.tableData[this.index].addressNo=res.addressNo
              this.addFormInfo.tableData[0].receiverid = this.addressList[0].id;
              this.addFormInfo.tableData[0].receiverCode = this.addressList[0].addressNo;
              this.receiverCode = this.addressList[0].addressNo;
              // 地址码
              this.addFormInfo.tableData[0].receivercity = this.addressList[0].city;
              this.addFormInfo.tableData[0].receiverarea = this.addressList[0].area;
              this.addFormInfo.tableData[0].receiverprovence = this.addressList[0].provence;
              this.addFormInfo.tableData[0].receiverzipCode = this.addressList[0].postcode;
              // 地址字
              this.addFormInfo.tableData[0].rcity = this.addressList[0].cityName;
              this.addFormInfo.tableData[0].rarea = this.addressList[0].areaName;
              this.addFormInfo.tableData[0].rprovence = this.addressList[0].provenceName;
              // console.log(this.addFormInfo.tableData[0]);
              // console.log(this.addressList[0]);
              //发件人
            } else {
              this.senderdisabled = false;
              // console.log(this.addressList[0]);
              this.addFormInfo.tableData[0].sender = this.addressList[0].receiverName;
              this.addFormInfo.tableData[0].senderPhone = this.addressList[0].receiverPhone;
              this.addFormInfo.tableData[0].sendAddress = this.addressList[0].addressInfo;
              this.addFormInfo.tableData[0].senderdefaultAddress = this.addressList[0].defaultAddress;
              this.addFormInfo.tableData[0].senderid = this.addressList[0].id;
              this.addFormInfo.tableData[0].senderCode = this.addressList[0].addressNo;
              // 地址码
              this.addFormInfo.tableData[0].sendercity = this.addressList[0].city;
              this.addFormInfo.tableData[0].senderarea = this.addressList[0].area;
              this.addFormInfo.tableData[0].senderprovence = this.addressList[0].provence;
              // 地址字
              this.addFormInfo.tableData[0].scity = this.addressList[0].cityName;
              this.addFormInfo.tableData[0].sarea = this.addressList[0].areaName;
              this.addFormInfo.tableData[0].sprovence = this.addressList[0].provenceName;
              this.addFormInfo.tableData[0].senderzipCode = this.addressList[0].postcode;
            }
          }
        });
      }
      this.addVisible = false;
      // this.$forceUpdate();
      this.randomKey = Math.random();
      this.$set(this.addFormInfo, 'tableData', this.addFormInfo.tableData);
      console.log('new', this.newArr);
    },
    handleSizeChange (newSize) {
      this.addsearch.pageSize = newSize;
      this.no_searchList();
    },
    handleCurrentChange (newPage) {
      this.addsearch.pageNum = newPage;
      this.no_searchList();
    },
    addCancel () {
      this.addVisible = false;

      this.addsearch = {
        receiverName: '',
        type: '',
        pageSize: 10,
        pageNum: 1
      };
    },
    addClear () {
      this.addsearch.receiverName = '';
      this.addsearch.pageSize = 10;
      this.addsearch.pageNum = 1;
    },
    async searchList () {
      this.addsearch.pageNum = 1;
      this.addsearch.pageSize = 10;
      const { data: res } = await this.$http.get('cms/configAddressInfo/list', { params: this.addsearch });
      this.addressList = res.data.list;
      this.addsearch.pageNum = res.data.pageNum;
      this.addsearch.pageSize = res.data.pageSize;
      this.addsearch.total = res.data.total;
      res.data.list.map((res, index) => {
        if (res.defaultAddress == 1) {
          this.changeadd = index;
        }
      });
    },
    async no_searchList () {
      const { data: res } = await this.$http.get('cms/configAddressInfo/list', { params: this.addsearch });
      this.addressList = res.data.list;
      this.addsearch.pageNum = res.data.pageNum;
      this.addsearch.pageSize = res.data.pageSize;
      this.addsearch.total = res.data.total;

      res.data.list.map((res, index) => {
        if (res.defaultAddress == 1) {
          this.changeadd = index;
        }
      });
      // console.log(this.addressList);
    },

    changeaddress (num, type, index) {
      //num为下标
      //type=0为收件人1为发件人
      this.addVisible = true;
      this.addsearch.type = type;
      this.index = index;
      this.type = type;
      this.searchList();
      if (num === 0) {
        this.addresstit = this.$t('createOrder.createOrder67');
      } else {
        this.addresstit = this.$t('address.address14');
      }
    },
    toRecharge () {
      this.$router.push({
        name: 'recharge'
      });
    },

    beforeUploadVideo (index) {
      // console.log(index)
      this.curRowPDF = index;
    },
    beforeUploadImg (index) {
      // console.log(index)
      this.curRowImg = index;
    },
    beforeUploadFile (index) {
      // console.log(index)
      this.curRowFile = index;

      // const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      // const whiteList = ["pdf", "doc", "docx", "xls", "xlsx"];

      // if (whiteList.indexOf(fileSuffix) === -1) {
      //   this.$message.error('上传文件只能是 pdf、doc、docx、xls、xlsx格式');
      //   return false;
      // }

      // const isLt2M = file.size / 1024 / 1024 < 20;

      // if (!isLt2M) {
      //   this.$message.error('上传文件大小不能超过 20MB');
      //   return false;
      // }
    },
    delPdf (row) {
      this.$confirm(this.$t('createOrder.createOrder68'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: 'form-btn btn-gray'
      })
        .then(() => {
          row.pdfName = '';
          row.pdfUrl = '';
          this.$message({
            type: 'success',
            message: this.$t('createOrder.createOrder69')
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('createOrder.createOrder70')
          });
        });
    },
    delFile (row) {
      this.$confirm(this.$t('createOrder.createOrder68'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: 'form-btn btn-gray'
      })
        .then(() => {
          row.inspectionFileName = '';
          row.inspectionFileUrl = '';
          this.$message({
            type: 'success',
            message: this.$t('createOrder.createOrder69')
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('createOrder.createOrder70')
          });
        });
    },
    async delImg (row, index) {
      var _this = this;
      this.$confirm(this.$t('createOrder.createOrder71'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: 'form-btn btn-gray',
        type: 'warning'
      })
        .then(() => {
          // let formdata = new FormData();
          // formdata.append('fileUrl',row.pictureUrl)
          // this.$http.post('aliyun/oss/delFile',formdata).then(res=>{
          //   if(res.data.code == 200){
          //     _this.$message({
          //       type: 'success',
          //       message: res.data.message
          //     });
          //     row.pictureName = '';
          //     row.pictureUrl = '';
          //   }
          //   else{
          //     _this.$message({
          //       type: 'error',
          //       message: res.data.message
          //     });
          //   }
          // });
          this.addFormInfo.tableData[index].pictureUrl = [];
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('createOrder.createOrder70')
          });
        });
    },

    //上传pdf
    uploadVideo (file) {
      let _self = this;
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);
      const whiteList = ['pdf', 'ai'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message.error('上传文件只能是 pdf、ai 格式');
        _self.$message.error(this.$t('createOrder.createOrder98'));
        return;
      }

      const isLt2M = file.file.size / 1024 / 1024 < 20;

      if (!isLt2M) {
        // this.$message.error('上传文件大小不能超过 20MB');
        _self.$message.error(this.$t('createOrder.createOrder97'));
        return;
      }

      // const isPDF = file.file.type === "application/pdf";
      // if (!isPDF) {
      //   _self.$message.error(this.$t('createOrder.createOrder72'));
      //   return;
      // }
      let formdata = new FormData();
      formdata.append('file', file.file);
      formdata.append('modular', 'OrderDetail');
      formdata.append('fileType', '');
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          _self.addFormInfo.tableData[this.curRowPDF].pdfUrl = res.data.data;
          _self.addFormInfo.tableData[this.curRowPDF].pdfName = res.data.data.split('OrderDetail/')[1];
          _self.$message.success(this.$t('createOrder.createOrder73'));
        }
      });
    },
    //上传检品文件
    uploadFile (file) {
      let _self = this;
      // console.log('filefilefilefile');
      // console.log(file.file)
      // console.log(file.file.name)
      const fileSuffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      const whiteList = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'jpg', 'jpeg', 'png', 'gif'];

      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message.error('上传文件只能是 doc、docx、xls、xlsx、ppt、pptx、pdf、txt、jpg、jpge、png、gif格式');
        _self.$message.error(this.$t('createOrder.createOrder96'));
        return;
      }

      const isLt2M = file.file.size / 1024 / 1024 < 20;

      if (!isLt2M) {
        // this.$message.error('上传文件大小不能超过 20MB');
        _self.$message.error(this.$t('createOrder.createOrder97'));
        return;
      }
      // const isPDF = file.file.type === "application/pdf";
      // if (!isPDF) {
      //   _self.$message.error(this.$t('createOrder.createOrder72'));
      //   return;
      // }
      let formdata = new FormData();
      formdata.append('file', file.file);
      formdata.append('modular', 'OrderDetail');
      formdata.append('fileType', '');
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          _self.addFormInfo.tableData[this.curRowFile].inspectionFileUrl = res.data.data;
          _self.addFormInfo.tableData[this.curRowFile].inspectionFileName = res.data.data.split('OrderDetail/')[1];
          _self.$message.success(this.$t('createOrder.createOrder73'));
        }
      });
    },
    //上传图片
    uploadImg (file) {
      let _self = this;
      // console.log(file.file)
      const isJPG = file.file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
      if (!isJPG) {
        _self.$message.error(this.$t('createOrder.createOrder74'));
        return;
      }
      let formdata = new FormData();
      formdata.append('file', file.file);
      // console.log('img-upload')
      // console.log(file);
      formdata.append('modular', 'createOrder');
      formdata.append('fileType', '');
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          _self.addFormInfo.tableData[this.curRowImg].pictureUrl = res.data.data;
          _self.addFormInfo.tableData[this.curRowImg].pictureName = res.data.data.split('createOrder/')[1];
          _self.$message.success(this.$t('createOrder.createOrder73'));
          // console.log(_self.addFormInfo.tableData[this.curRowImg].pictureName, '==================')
          // console.log(res.data.data)
        } else {
          _self.$message.error(this.$t('createOrder.createOrder75'));
        }
      });
    },
    //检品选项
    configCheckChanged (row) {
      row.configCheckProjectArray = [];
      row.configCheckProjectArray = row.configCheckProjectOrigin.join(',');
      // console.log("检品选项：======》》》"+row.configCheckProjectArray);
      if (row.configCheckProjectArray && row.configCheckProjectArray.indexOf('laundryLabel') > -1) {
        this.$set(row, 'isTempDisabled', true);
      } else {
        row.laundryLabelId = '';
        this.$set(row, 'isTempDisabled', false);
      }
    },
    //图片上传
    showImgDialog (index) {
      this.imgDialogVisible = true;
      this.curRow = index;
    },
    handleImgSubmit () {
      const arr = Object.keys(this.listObj).map((v) => this.listObj[v]);
      if (!Oss.checkAllSuccess(this.listObj)) {
        this.$message(this.$t('createOrder.createOrder76'));
        return;
      } else {
        if (arr.length > 1) {
          this.$message.error(this.$t('createOrder.createOrder77'));
        } else {
          if (arr.length > 0) {
            this.addFormInfo.tableData[this.curRow].pictureUrl = arr[0].url;
          }
          this.$emit('successCBK', arr);
          this.listObj = {};
          this.imgFileList = [];
          this.imgDialogVisible = false;
        }
      }
    },

    beforeImgUpload (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get('aliyun/oss/policy')
          .then((response) => {
            var num = ''; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
            _self.imgDataObj.dir = response.data.data.dir + '/order';
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num
            Oss.imgCompress(file, this.listObj, resolve, reject);
            // console.log('before-upload');
            // console.log(file);
          })
          .catch((err) => {
            // console.log(err)
            reject(false);
          });
      });
    },
    //pdf上传
    // handlePdfRemove(file) {
    //   Oss.imgRemove(file, this.pdfListObj);
    // },
    // handlePdfSuccess(file) {
    //   Oss.imgSuccess(file, this.pdfListObj, this.pdfDataObj);
    // },
    beforePdfUpload (file) {
      // console.log(file);
      const _self = this;
      const fileName = file.uid;
      this.pdfListObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get('aliyun/oss/policy')
          .then((response) => {
            var num = ''; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.pdfDataObj.policy = response.data.data.policy;
            _self.pdfDataObj.signature = response.data.data.signature;
            _self.pdfDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.pdfDataObj.key = response.data.data.dir + '/order/' + num + file.name;
            _self.pdfDataObj.dir = response.data.data.dir + '/order';
            _self.pdfDataObj.host = response.data.data.host;
            _self.pdfDataObj.timeStamp = num;
            // console.log('mmmmmm');
            // console.log(_self.pdfDataObj);
            let arr = [
              {
                hasSuccess: true,
                height: undefined,
                uid: file.uid,
                url: _self.pdfDataObj.host + '/' + _self.pdfDataObj.key,
                width: undefined
              }
            ];
            // this.addFormInfo.tableData[this.curRow].pdfUrl = arr[0].url;
            this.$emit('successCBK', arr);
            this.pdfListObj = {};
            resolve(true);
          })
          .catch((err) => {
            // console.log(err)
            reject(false);
          });
      });
    },
    beforeFileUpload (file) {
      // console.log(file);
      const _self = this;
      const fileName = file.uid;
      this.fileListObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get('aliyun/oss/policy')
          .then((response) => {
            var num = ''; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.fileDataObj.policy = response.data.data.policy;
            _self.fileDataObj.signature = response.data.data.signature;
            _self.fileDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.fileDataObj.key = response.data.data.dir + '/order/' + num + file.name;
            _self.fileDataObj.dir = response.data.data.dir + '/order';
            _self.fileDataObj.host = response.data.data.host;
            _self.fileDataObj.timeStamp = num;
            let arr = [
              {
                hasSuccess: true,
                height: undefined,
                uid: file.uid,
                url: _self.fileDataObj.host + '/' + _self.fileDataObj.key,
                width: undefined
              }
            ];
            this.$emit('successCBK', arr);
            this.fileListObj = {};
            resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },

    //选择是否fba
    orderTypeChange (val, index, row) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate();
      });
      if (val == 1) {
        this.addFormInfo.addFormInfoRules[index].fnsku[0].required = false;
        row.fnsku = '';
        row.goodsNameCus = '';
        this.$set(row, 'fnskuDisabled', false);
      } else {
        this.addFormInfo.addFormInfoRules[index].fnsku[0].required = true;
        this.addFormInfo.addFormInfoRules[index].goodsNameCus[0].required = true;
        this.$set(row, 'fnskuDisabled', true);
      }
      if (val == 1) {
        this.addFormInfo.addFormInfoRules[index].skuLabel = 'コード';
        this.$set(row, 'skuLabel', 'コード');
        this.addFormInfo.addFormInfoRules[index].skuPlaceolder = '';
        this.$set(row, 'skuPlaceolder', '');
      }
      if (val == 0) {
        this.addFormInfo.addFormInfoRules[index].skuLabel = 'FNSKU';
        this.addFormInfo.addFormInfoRules[index].skuPlaceolder = 'X00000001';
        this.$set(row, 'skuPlaceolder', 'X00000001');
        this.$set(row, 'skuLabel', 'FNSKU');
      }
      if (val == 2) {
        this.addFormInfo.addFormInfoRules[index].skuLabel = 'YFFコード';
        this.addFormInfo.addFormInfoRules[index].skuPlaceolder = 'hello-red';
        this.$set(row, 'skuPlaceolder', 'hello-red');
        this.$set(row, 'skuLabel', 'YFFコード');
      }
      if (val == 3) {
        this.addFormInfo.addFormInfoRules[index].skuLabel = 'ZOZOコード';
        this.addFormInfo.addFormInfoRules[index].skuPlaceolder = 'ICH123456789';
        this.$set(row, 'skuPlaceolder', 'ICH123456789');
        this.$set(row, 'skuLabel', 'ZOZOコード');
      }
      if (val == 4) {
        this.addFormInfo.addFormInfoRules[index].skuLabel = 'JANコード';
        this.addFormInfo.addFormInfoRules[index].skuPlaceolder = '123456789';
        this.$set(row, 'skuPlaceolder', '123456789');
        this.$set(row, 'skuLabel', 'JANコード');
      }

    },
    //组件层级过深 无法刷新
    orderNoChange () {
      this.$forceUpdate();
    },
    delOrder (row, index) {
      this.$confirm(this.$t('createOrder.createOrder78'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: 'form-btn btn-gray',
        type: 'warning'
      })
        .then(() => {
          if (this.addFormInfo.tableData.length === 1) {
            this.$message.error(this.$t('createOrder.createOrder79'));
          } else {
            this.addFormInfo.tableData.splice(index, 1);
            this.addFormInfo.addFormInfoRules.splice(index, 1);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('createOrder.createOrder70')
          });
        });
    },
    addOrder () {
      var lastOrder = this.addFormInfo.tableData[this.addFormInfo.tableData.length - 1];
      // console.log(lastOrder);
      this.addFormInfo.tableData.push({
        trackingNumberCn: '',
        taobaoUrl: '',
        goodsName: '',
        goodsCount: '',
        colour: '',
        goodsSize: '',
        price: '',
        goodsNumber: '',
        agentFlag: this.agentFlagState, // 根据后台管理段
        categoryFlag: lastOrder.categoryFlag,
        // orderType: lastOrder.orderType,
        orderType: '1',
        putIntent: lastOrder.putIntent,
        laundryLabelId: lastOrder.laundryLabelId,
        customerRemark: lastOrder.customerRemark,
        // fnsku: lastOrder.fnsku,
        fnsku: '',
        configCheckProjectArray: 'baseCheck',
        configCheckProjectOrigin: ['baseCheck'],
        isTempDisabled: false,
        fnskuDisabled: false,
        freightDisabled: true,
        chineseFreightFee: 0,
        goodsNameCus: '',
        trackingNumberCnType: true,
        pictureUrl: '',
        pictureName: '',
        pdfName: '',
        pdfUrl: '',
        inspectionFileName: '',
        inspectionFileUrl: '',
        /* receiver: lastOrder.receiver,
        senderCode: lastOrder.receiver,
        receiverCode: lastOrder.receiverCode,
        receiverPhone: lastOrder.receiverPhone,
        zipCode: lastOrder.zipCode,
        receiverzipCode: lastOrder.receiverzipCode,
        receiverAddress: lastOrder.receiverAddress,
        receiverprovence: parseInt(lastOrder.receiverprovence),
        receivercity: parseInt(lastOrder.receivercity),
        receiverarea: parseInt(lastOrder.receiverarea),
        receiveraddressInfo: lastOrder.receiveraddressInfo,
        receivernote: lastOrder.receivernote,
        receiverdefaultAddress: lastOrder.receiverdefaultAddress,
        receiverid: lastOrder.receiverid,
        sender: lastOrder.sender,
        senderPhone: lastOrder.senderPhone,
        sendAddress: lastOrder.sendAddress,
        addressInfo: lastOrder.addressInfo,
        // res.sendernote = item.postcode
        senderprovence: parseInt(lastOrder.senderprovence),
        sendercity: parseInt(lastOrder.sendercity),
        senderarea: parseInt(lastOrder.senderarea),
        senderaddressInfo: lastOrder.senderaddressInfo,
        senderzipCode: lastOrder.senderzipCode,
        // res.zipCode = item.postcode

        senderdefaultAddress: lastOrder.senderdefaultAddress,
        senderid: lastOrder.senderid */
      });
      // console.log('this.addFormInfo.tableData',this.addFormInfo.tableData)
      this.randomKey = Math.random();
      if (lastOrder.orderType == '0') {
        this.addFormInfo.addFormInfoRules.push({
          goodsCount: [
            {
              required: true,
              message: this.$t('createOrder.createOrder80'),
              trigger: 'blur'
            }
          ],
          colour: [
            {
              required: true,
              message: this.$t('createOrder.createOrder81'),
              trigger: 'blur'
            }
          ],
          price: [
            {
              required: true,
              message: this.$t('createOrder.createOrder82'),
              trigger: 'blur'
            }
          ],
          chineseFreightFee: [
            {
              required: true,
              message: this.$t('createOrder.createOrder115'),
              trigger: 'blur'
            }
          ],
          trackingNumberCn: [
            {
              required: true,
              message: this.$t('createOrder.createOrder62'),
              trigger: 'blur'
            },
            {
              pattern: /^[a-zA-Z0-9]+$/,
              message: this.$t('createOrder.createOrder63'),
              trigger: 'blur'
            }
          ],
          fnsku: [
            {
              required: true,
              message: this.$t('createOrder.createOrder84'),
              trigger: 'blur'
            }
          ],
          goodsNameCus: [
            {
              required: true,
              message: this.$t('createOrder.createOrder114'),
              trigger: 'blur'
            }
          ],
          goodsName: [
            {
              required: false,
              message: this.$t('createOrder.createOrder85'),
              trigger: 'blur'
            }
          ],
          /* sender: [
            {
              required: false,
              message: this.$t('address.address39'),
              trigger: 'blur'
            }
          ],
          senderPhone: [
            {
              required: false,
              message: this.$t('address.address34'),
              trigger: 'blur'
            }
          ],
          sendAddress: [
            {
              required: false,
              message: this.$t('createOrder.createOrder86'),
              trigger: 'blur'
            }
          ],
          receiver: [{ required: false, message: this.$t('address.address39') }],
          receiverPhone: [
            {
              required: false,
              message: this.$t('address.address34'),
              trigger: 'blur'
            }
          ],
          zipCode: [
            {
              required: false,
              message: this.$t('address.address35'),
              trigger: 'blur'
            }
          ],
          receiverAddress: [
            {
              required: false,
              message: this.$t('createOrder.createOrder86'),
              trigger: 'blur'
            }
          ], */
          laundryLabelId: [
            {
              required: true,
              message: this.$t('createOrder.createOrder87'),
              trigger: 'blur'
            }
          ]
        });
      } else {
        this.addFormInfo.addFormInfoRules.push({
          goodsCount: [
            {
              required: true,
              message: this.$t('createOrder.createOrder80'),
              trigger: 'blur'
            }
          ],
          colour: [
            {
              required: true,
              message: this.$t('createOrder.createOrder81'),
              trigger: 'blur'
            }
          ],
          price: [
            {
              required: true,
              message: this.$t('createOrder.createOrder82'),
              trigger: 'blur'
            }
          ],
          trackingNumberCn: [
            {
              required: true,
              message: this.$t('createOrder.createOrder62'),
              trigger: 'blur'
            },
            {
              pattern: /^[a-zA-Z0-9]+$/,
              message: this.$t('createOrder.createOrder63'),
              trigger: 'blur'
            }
          ],
          chineseFreightFee: [
            {
              required: true,
              message: this.$t('createOrder.createOrder115'),
              trigger: 'blur'
            }
          ],
          fnsku: [
            {
              required: false,
              message: this.$t('createOrder.createOrder84'),
              trigger: 'blur'
            }
          ],
          goodsNameCus: [
            {
              required: true,
              message: this.$t('createOrder.createOrder114'),
              trigger: 'blur'
            }
          ],
          goodsName: [
            {
              required: false,
              message: this.$t('createOrder.createOrder85'),
              trigger: 'blur'
            }
          ],
          /* sender: [{ required: true, message: this.$t('address.address39') }],
          senderPhone: [
            {
              required: true,
              message: this.$t('address.address34'),
              trigger: 'blur'
            }
          ],
          sendAddress: [
            {
              required: true,
              message: this.$t('createOrder.createOrder86'),
              trigger: 'blur'
            }
          ],
          receiver: [{ required: true, message: this.$t('address.address39') }],
          receiverPhone: [
            {
              required: true,
              message: this.$t('address.address34'),
              trigger: 'blur'
            }
          ],
          zipCode: [
            {
              required: true,
              message: this.$t('address.address35'),
              trigger: 'blur'
            }
          ],
          receiverAddress: [
            {
              required: true,
              message: this.$t('createOrder.createOrder86'),
              trigger: 'blur'
            }
          ], */
          laundryLabelId: [
            {
              required: true,
              message: this.$t('createOrder.createOrder87'),
              trigger: 'blur'
            }
          ]
        });
      }
    },
    async getInspectionOption () {
      const { data: res } = await this.$http.get('order/getNameList', {
        params: { nameClass: 'INSPECTION' }
      });
      this.inspectionOption = res.data;
    },
    async getLaundryLabelOption () {
      const { data: res } = await this.$http.get('laundry/label/template/getAll');
      this.laundryLabelOption = res.data;
    },
    async getUserInfo () {
      const { data: res } = await this.$http.get('customer/getCustomerInfo');
      this.userInfo = res.data;
      if (res.data.hotboomFlag === '1') {
        this.agentFlagType = false;
        this.agentFlagState = '1';
      } else {
        this.agentFlagType = true;
        this.agentFlagState = '0';
      }
    },
    async postOrderForm () {
      if (this.$route.query.orders) {
        this.addFormInfo.tableData.forEach((item) => {
          for (const key in item) {
            if (key === '0') {
              delete item[key];
            }
          }
        });
      }
      const params = this._.cloneDeep(this.addFormInfo);
      // console.log('绑定的数据',this.add_addressList)
      params.tableData.map((res, index) => {
        // console.log('this.newArr[index].receiverAddress',this.newArr,index)
        /* if (this.newArr.length !== 0) {
          // if (res.rprovence) {
          // res.receiverAddress = `${res.rprovence}${res.rcity}${res.rarea}${res.receiverAddress}`
          if (this.newArr[index]) {
            if (this.newArr[index].receiverAddress) {
              res.receiverAddress = this.newArr[index].receiverAddress + `${res.receiverAddress}`;
            } else {
              res.receiverAddress = this.receiverLis.rprovence + this.receiverLis.rcity + this.receiverLis.rarea + `${res.receiverAddress}`;
            }
            if (this.newArr[index].sendAddress) {
              res.sendAddress = this.newArr[index].sendAddress + `${res.sendAddress}`;
            } else {
              res.sendAddress = this.senderLis.sprovence + this.senderLis.scity + this.senderLis.sarea + `${res.sendAddress}`;
            }
          } else {
            res.receiverAddress = this.receiverLis.rprovence + this.receiverLis.rcity + this.receiverLis.rarea + `${res.receiverAddress}`;
            res.sendAddress = this.senderLis.sprovence + this.senderLis.scity + this.senderLis.sarea + `${res.sendAddress}`;
          }
          // }
          // if (res.sprovence) {
          //   res.sendAddress = `${res.sprovence}${res.scity}${res.sarea}${res.sendAddress}`
          // res.sendAddress = this.newArr[index].sendAddress+`${res.sendAddress}`
          // }
          // else {
          //   this.echo.map((val)=>{
          //     if(val.id === res.id) {
          //       res.receiverAddress = val.receiverAddress
          //       res.sendAddress = val.sendAddress
          //     }
          //   })
          // }
        } else {
          res.receiverAddress = this.receiverLis.rprovence + this.receiverLis.rcity + this.receiverLis.rarea + `${res.receiverAddress}`;
          res.sendAddress = this.senderLis.sprovence + this.senderLis.scity + this.senderLis.sarea + `${res.sendAddress}`;
        } */
        if (res.agentFlag == 1) {
          res.trackingNumberCn = '';
        }
        this.randomKey = Math.random();
      });
      // console.log('params',params)
      const { data: res } = await this.$http.post('order/create', {
        orderListStr: JSON.stringify(params.tableData)
      });
      if (res.code == 200) {
        this.$message.success(res.message);
        this.$router.push({
          name: 'orderList'
        });
      } else {
        this.$message.error(res.message);
      }
    },
    // async getConfigLists(){
    //   const {data:res} = await this.$http.get('order/getOrderInfoConfigList');
    //   this.configLists = res.data;
    //  // console.log(this.configLists);
    // },
    saveForm () {
      var _this = this;
      /* this.addFormInfo.tableData.map((res) => {
        res.zipCode = res.receiverzipCode;
        this.receiverzipCode = res.receiverzipCode;
      }); */

      this.$refs.addForm.validate(function (valid) {
        // console.log(valid)
        if (valid) {
          _this.postOrderForm();
        }
      });
    },
    cancelForm () {
      this.$refs.addForm.clearValidate();
      this.$router.push({
        name: 'orderList'
      });
    },
    goodsCancel () {
      this.$refs.productDetailForm.resetFields();
      this.goodsDialogVisible = false;
    },
    goodsSave () {
      this.addFormInfo.tableData[this.editCurRow].goodsName = this.productName;
      this.addFormInfo.tableData[this.editCurRow].goodsSize = '';
      this.addFormInfo.tableData[this.editCurRow].colour = '';
      // this.addFormInfo.tableData[this.editCurRow].pictureUrl = ''
      this.addFormInfo.tableData[this.editCurRow].goodsCount = this.productForm.quantity;
      this.addFormInfo.tableData[this.editCurRow].price = this.productForm.skuPrice;
      this.addFormInfo.tableData[this.editCurRow].pictureUrl = this.SelectedAttrImgUrl;
      if (this.selectedSku.sku_id) {
        this.selectedSku.properties_name.forEach((el) => {
          if (el.name == this.pullSize) {
            this.addFormInfo.tableData[this.editCurRow].goodsSize = el.value;
          }
          if (el.name == this.pullName) {
            this.addFormInfo.tableData[this.editCurRow].colour = el.value;
          }
        });
      }
      this.goodsDialogVisible = false;
    },
    async blurTaobaoUrl (url, index) {
      if (this.flag == false) {
        if (url.length > 0) {
          this.SelectedAttrImgUrl = '';
          var _this = this;
          const { data: res } = await this.$http.get('order/getGoodsInfo', { params: { url: url } });
          if (res.code != '200') {
            this.$message.error(res.message);
          } else {
            console.log('拉回来得信息', res)
            this.goodsDialogVisible = true;
            this.flag = true
            this.productName = res.data.title;
            // this.getData();
            this.specificationList = res.data.specificationList;
            _this.pullSize = this.specificationList.some((item) => item.colorFlag == 0)
              ? this.specificationList.find((item) => item.colorFlag == 0).name
              : this.specificationList.some((item) => item.colorFlag == 2)
                ? this.specificationList.find((item) => item.colorFlag == 2).name
                : '';
            _this.pullName = this.specificationList.some((item) => item.colorFlag == 1)
              ? this.specificationList.find((item) => item.colorFlag == 1).name
              : this.specificationList.some((item) => item.colorFlag == 2)
                ? this.specificationList.find((item) => item.colorFlag == 2).name
                : '';
            this.specificationList.forEach((el) => {
              el.value.forEach((el2) => {
                _this.$set(el2, 'checked', '0');
              });
            });
            this.productArray = res.data.skuList;
            _this.SelectedAttrImgUrl = res.data.picUrl
            // if (this.specificationList.length <= 0) {
            // 	return false;
            // }
            // if (this.specificationList[0].value[0].url !== '') {
            // 	_this.SelectedAttrImgUrl = this.specificationList[0].value[0].url;
            // } else if (this.specificationList.length > 1) {
            // 	if (this.specificationList[1].value[0].url !== '') {
            // 		_this.SelectedAttrImgUrl = this.specificationList[1].value[0].url;
            // 	}
            // }
          }
          this.editCurRow = index;
        }
      }
      // console.log(index)

    },
    // // 商品詳情
    // smImgClick(item){
    //     this.isInSmImg = 1;
    //     this.imgUrls.forEach(function (el) {
    //         el.select = 0;
    //     })
    //     item.select = 1;
    // },
    tagClick (item2, item) {
      if (item.colorcolorFlag == '1') {
        this.isInSmImg = 0;
      }
      item.value.forEach(function (el) {
        el.checked = '0';
      });
      item2.checked = '1';
      //选择颜色，左侧图片联动
      if (item2.url) {
        this.SelectedAttrImgUrl = item2.url;
      }
      // if (item.colorFlag == 1) {
      //   this.SelectedAttrImgUrl = item2.url;
      // } else if (item.colorFlag == 2) {
      //   this.SelectedAttrImgUrl = item2.url;
      // }
      this.getSku();
    },
    countTotalStock (arr) {
      let count = 0;
      arr.forEach(function (el) {
        count += Number(el.quantity);
      });
      return count;
    },
    countSortPrice (arr) {
      var count = 0;
      var priceArr = [];
      arr.forEach(function (el) {
        priceArr.push(el.price);
      });
      priceArr.sort(function (a, b) {
        return a - b;
      });
      return priceArr;
    },
    //判断对象数组元素相同
    judgeResultFun (arr1, arr2) {
      let flag = true;
      if (arr1.length !== arr2.length) {
        flag = false;
      } else {
        arr1.forEach((item) => {
          if (arr2.indexOf(item) === -1) {
            flag = false;
          }
        });
      }
      return flag;
    },
    getSku () {
      let selectskuattrs = [];
      let attrCount = this.specificationList.length;
      let selectAttrCount = 0;
      this.specificationList.forEach(function (el) {
        el.value.forEach(function (el2) {
          if (el2.checked == '1') {
            selectAttrCount++;
            selectskuattrs.push({
              name: el.name,
              value: el2.name
            });
          }
        });
      });
      var _this = this;
      if (attrCount == selectAttrCount) {
        this.productArray.forEach(function (el) {
          if (JSON.stringify(el.properties_name) === JSON.stringify(selectskuattrs)) {
            _this.selectedSku = el;
            console.log('_this.selectedSku', _this.selectedSku);
            _this.productForm.skuPrice = el.price;
            //_this.productForm.quantity = el.quantity;
          }
        });
      }
    },
    getData () {
      this.specificationList = [
        {
          name: this.$t('orderList.orderList26'),
          isColor: '1',
          value: [
            {
              name: this.$t('createOrder.createOrder88'),
              checked: 0,
              customerRemark: 111,
              url: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3069634427,1111848643&fm=26&gp=0.jpg'
            },
            {
              name: this.$t('createOrder.createOrder89'),
              checked: 0,
              customerRemark: '',
              url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage.biaobaiju.com%2Fuploads%2F20190504%2F20%2F1556973820-abgJFyvrIw.png&refer=http%3A%2F%2Fimage.biaobaiju.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1618394429&t=0163cd457b9e01e5407e77d5b513180d'
            }
          ]
        },
        {
          name: this.$t('orderList.orderList27'),
          isColor: '0',
          value: [
            {
              name: 'L',
              checked: 0,
              customerRemark: 222,
              url: ''
            },
            {
              name: 'XL',
              checked: 0,
              customerRemark: '',
              url: ''
            }
          ]
        }
      ];
      this.productArray = [
        {
          sku_id: 'A1',
          properties_name: [
            { name: this.$t('orderList.orderList26'), value: this.$t('createOrder.createOrder88') },
            { name: this.$t('orderList.orderList27'), value: 'L' }
          ],
          quantity: '100',
          price: '108.5'
        },
        {
          sku_id: 'A1',
          properties_name: [
            { name: this.$t('orderList.orderList26'), value: this.$t('createOrder.createOrder88') },
            { name: this.$t('orderList.orderList27'), value: 'XL' }
          ],
          quantity: '90',
          price: '108.5'
        },
        {
          sku_id: 'A1',
          properties_name: [
            { name: this.$t('orderList.orderList26'), value: this.$t('createOrder.createOrder89') },
            { name: this.$t('orderList.orderList27'), value: 'L' }
          ],
          quantity: '98',
          price: '118.5'
        },
        {
          sku_id: 'A1',
          properties_name: [
            { name: this.$t('orderList.orderList26'), value: this.$t('createOrder.createOrder89') },
            { name: this.$t('orderList.orderList27'), value: 'XL' }
          ],
          quantity: '70',
          price: '118.5'
        }
      ];
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.fileList1.splice(i, 1)
        }
      }
    },
    handlePreview (file) {
      // console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')}，${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')}，${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      );
    },
    // 批量导入
    async excelUploadRequest (file) {
      if (this.exportNum === 1) this.addFormInfo.tableData = []
      this.exportNum += 1
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('order/importAction', formdata);
      if (res.code == 200) {
        res.data.forEach((el) => {
          el.configCheckProjectOrigin = el.configCheckProjectArray.split(',');
          this.addFormInfo.tableData.push(el);
          res.data.forEach((item) => {
            if (item.trackingNumberCn.length >= 50) {
              this.$message(this.$t('createOrder.createOrder90'));
            }
          });

          if (el.orderType && el.orderType == '1') {
            el.goodsNameCus = '';
            this.addFormInfo.addFormInfoRules.push({
              trackingNumberCn: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder62'),
                  trigger: 'blur'
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: this.$t('createOrder.createOrder63'),
                  trigger: 'blur'
                }
              ],
              goodsCount: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder80'),
                  trigger: 'blur'
                }
              ],
              colour: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder81'),
                  trigger: 'blur'
                }
              ],
              price: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder82'),
                  trigger: 'blur'
                }
              ],
              fnsku: [
                {
                  required: false,
                  message: this.$t('createOrder.createOrder84'),
                  trigger: 'blur'
                }
              ],
              goodsNameCus: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder114'),
                  trigger: 'blur'
                }
              ],
              goodsName: [
                {
                  required: false,
                  message: this.$t('createOrder.createOrder85'),
                  trigger: 'blur'
                }
              ],
              chineseFreightFee: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder115'),
                  trigger: 'blur'
                }
              ],
              /* sender: [{ required: true, message: this.$t('address.address39') }],
              senderPhone: [
                {
                  required: true,
                  message: this.$t('address.address34'),
                  trigger: 'blur'
                }
              ],
              sendAddress: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder86'),
                  trigger: 'blur'
                }
              ],
              receiver: [{ required: true, message: this.$t('address.address39') }],
              receiverPhone: [
                {
                  required: true,
                  message: this.$t('address.address34'),
                  trigger: 'blur'
                }
              ],
              zipCode: [
                {
                  required: true,
                  message: this.$t('address.address35'),
                  trigger: 'blur'
                }
              ],
              receiverAddress: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder86'),
                  trigger: 'blur'
                }
              ], */
              laundryLabelId: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder87'),
                  trigger: 'blur'
                }
              ]
            });
          } else {
            this.$set(el, 'fnskuDisabled', true);
            this.addFormInfo.addFormInfoRules.push({
              goodsCount: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder80'),
                  trigger: 'blur'
                }
              ],
              colour: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder81'),
                  trigger: 'blur'
                }
              ],
              price: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder82'),
                  trigger: 'blur'
                }
              ],
              trackingNumberCn: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder62'),
                  trigger: 'blur'
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: this.$t('createOrder.createOrder63'),
                  trigger: 'blur'
                }
              ],
              chineseFreightFee: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder115'),
                  trigger: 'blur'
                }
              ],
              fnsku: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder84'),
                  trigger: 'blur'
                }
              ],
              goodsNameCus: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder114'),
                  trigger: 'blur'
                }
              ],
              goodsName: [
                {
                  required: false,
                  message: this.$t('createOrder.createOrder85'),
                  trigger: 'blur'
                }
              ],
              /* sender: [{ required: false, message: this.$t('address.address39') }],
              senderPhone: [
                {
                  required: false,
                  message: this.$t('address.address34'),
                  trigger: 'blur'
                }
              ],
              sendAddress: [
                {
                  required: false,
                  message: this.$t('createOrder.createOrder86'),
                  trigger: 'blur'
                }
              ],
              receiver: [{ required: false, message: this.$t('address.address39') }],
              receiverPhone: [
                {
                  required: false,
                  message: this.$t('address.address34'),
                  trigger: 'blur'
                }
              ],
              zipCode: [
                {
                  required: false,
                  message: this.$t('address.address35'),
                  trigger: 'blur'
                }
              ],
              receiverAddress: [
                {
                  required: false,
                  message: this.$t('createOrder.createOrder86'),
                  trigger: 'blur'
                }
              ], */
              laundryLabelId: [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder87'),
                  trigger: 'blur'
                }
              ]
            });
          }
          if (el.orderType == 1) {
            this.$set(el, 'skuLabel', 'コード');
            this.$set(el, 'skuPlaceolder', '');
          }
          if (el.orderType == 0) {
            this.$set(el, 'skuPlaceolder', 'X00000001');
            this.$set(el, 'skuLabel', 'FNSKU');
          }
          if (el.orderType == 2) {
            this.$set(el, 'skuPlaceolder', 'hello-red');
            this.$set(el, 'skuLabel', 'YFFコード');
          }
          if (el.orderType == 3) {
            this.$set(el, 'skuPlaceolder', 'ICH123456789');
            this.$set(el, 'skuLabel', 'ZOZOコード');
          }
          if (el.orderType == 4) {
            this.$set(el, 'skuPlaceolder', '123456789');
            this.$set(el, 'skuLabel', 'JANコード');
          }
          this.addFormInfo.tableData.map((res, index) => {
            if (res.agentFlag == 1) {
              this.addFormInfo.addFormInfoRules[index].trackingNumberCn = {
                required: false,
                message: this.$t('createOrder.createOrder62'),
                trigger: 'blur'
              };
              this.addFormInfo.tableData[index].trackingNumberCnType = false;
              this.$set(el, 'freightDisabled', true);
              this.addFormInfo.addFormInfoRules[index].chineseFreightFee = {
                required: true,
                message: this.$t('createOrder.createOrder115'),
                trigger: 'blur'
              };
            } else {
              this.addFormInfo.addFormInfoRules[index].trackingNumberCn = [
                {
                  required: true,
                  message: this.$t('createOrder.createOrder62'),
                  trigger: 'blur'
                },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: this.$t('createOrder.createOrder63'),
                  trigger: 'blur'
                }
              ];
              this.addFormInfo.tableData[index].trackingNumberCnType = true;
              res.chineseFreightFee = '';
              this.$set(el, 'freightDisabled', false);
              //this.addFormInfo.addFormInfoRules[index].chineseFreightFee[0].required = false;
            }
          });
        });
      } else {
        this.$message.error(res.message);
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    // 批量导入成功回调
    handleOrderInfo (data) {
      console.log('success')
      // console.log(data)
    },
    async downloadTemplate () {
      window.open('https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/instructions/template.xlsm', "_blank");
      /*const {data:res} = await this.$http.post('order/downloadTemplateAction',{});*/
      // var url = 'api/order/downloadTemplateAction'; // 请求的url + id
      // var xhr = new XMLHttpRequest();
      // xhr.open('GET', url, true);
      // xhr.responseType = 'blob';
      // xhr.setRequestHeader('client_type', 'DESKTOP_WEB');
      // xhr.setRequestHeader('Authorization', window.sessionStorage.getItem('token')); // 自定义请求头
      // xhr.onload = function () {
      //   if (this.status == 200) {
      //     var blob = this.response;
      //     var fileName = 'template.xlsx';
      //     if (window.navigator.msSaveOrOpenBlob) {
      //       // IE浏览器下
      //       navigator.msSaveBlob(blob, fileName);
      //     } else {
      //       var link = document.createElement('a');
      //       link.href = window.URL.createObjectURL(blob);
      //       link.download = fileName;
      //       link.click();
      //       window.URL.revokeObjectURL(link.href);
      //     }
      //   }
      // };
      // xhr.send();
    },
    SelectDefaultAddress () {
      // 收件地址
      var arr1 = 0;
      this.$http
        .get('cms/configAddressInfo/list', {
          params: {
            receiverName: '',
            type: '0',
            pageSize: 10,
            pageNum: 1
          }
        })
        .then((obj) => {
          obj.data.data.list.map((res) => {
            if (res.defaultAddress == 1) {
              arr1++;
              // this.disabled=false
              this.addFormInfo.tableData.map((item) => {
                // this.objTemp.receiverAddress = res.provenceName + res.cityName + res.areaName
                // this.newArr[this.index] = this._.cloneDeep(this.objTemp)
                item.receiver = res.receiverName;
                //item.sender = " ";
                this.receiverLis = {
                  rprovence: res.provenceName,
                  rcity: res.cityName,
                  rarea: res.areaName,
                  receiverCode: res.addressNo
                };
                this.receiverCode = res.addressNo;
                item.receiverPhone = res.receiverPhone;
                // item.receivernote = res.postcode
                item.receiverAddress = res.addressInfo;
                item.receiverprovence = res.provence;
                item.receivercity = res.city;
                item.receiverarea = res.area;
                item.rprovence = res.provenceName;
                item.rcity = res.cityName;
                item.rarea = res.areaName;
                item.receiveraddressInfo = res.addressInfo;
                item.receiverzipCode = res.postcode;
                item.receiverdefaultAddress = res.defaultAddress;
                item.receiverid = res.id;
                item.receiverCode = res.addressNo;
                this.randomKey = Math.random();
                // item.addressNo=res.addressNo
              });
            }
          });
          if (arr1 === 0) {
            this.reivedisabled = true;
          } else {
            this.reivedisabled = false;
          }
        });
      // 发件地址
      var arr2 = 0;
      this.$http
        .get('cms/configAddressInfo/list', {
          params: {
            receiverName: '',
            type: '1',
            pageSize: 10,
            pageNum: 1
          }
        })
        .then((obj) => {
          obj.data.data.list.map((res) => {
            if (res.defaultAddress == 1) {
              arr2++;
              this.addFormInfo.tableData.map((item) => {
                this.senderLis = {
                  sprovence: res.provenceName,
                  scity: res.cityName,
                  sarea: res.areaName,
                  senderCode: res.addressNo
                };
                this.senderCode = res.addressNo;
                // this.objTemp.sendAddress = res.provenceName + res.cityName + res.areaName
                // this.newArr[this.index] = this._.cloneDeep(this.objTemp)
                item.sender = res.receiverName;
                item.senderPhone = res.receiverPhone;
                item.sendAddress = res.addressInfo;
                item.addressInfo = res.addressInfo;
                item.note = res.notes;
                item.senderprovence = res.provence;
                item.sendercity = res.city;
                item.senderarea = res.area;
                item.sprovence = res.provenceName;
                item.scity = res.cityName;
                item.sarea = res.areaName;
                item.senderaddressInfo = res.addressInfo;
                item.senderzipCode = res.postcode;
                // item.sendernote = res.postcode;
                item.senderdefaultAddress = res.defaultAddress;
                item.senderid = res.id;
                item.senderCode = res.addressNo;
                this.randomKey = Math.random();
                // item.addressNo=res.addressNo
              });
            }
          });
          if (arr2 === 0) {
            this.senderdisabled = true;
          } else {
            this.senderdisabled = false;
          }
        });
      // console.log(this.addFormInfo.tableData);
      this.$forceUpdate();
    }
  },

  async created () {
    await this.getUserInfo();
    if (this.$route.query.orders) {
      let fromInfo = JSON.parse(this.$route.query.orders);
      fromInfo.forEach((el) => {
        if (el.configCheckProjectArray && el.configCheckProjectArray.indexOf('laundryLabel') > -1) {
          this.$set(el, 'isTempDisabled', true);
        } else {
          el.laundryLabelId = '';
          this.$set(el, 'isTempDisabled', false);
        }
        if (el.configCheckProjectArray) {
          this.$set(el, 'configCheckProjectOrigin', el.configCheckProjectArray.split(','));
        }
        if (el.orderType && el.orderType == "0") {
          this.$set(el, 'fnskuDisabled', true);
        } else {
          el.fnsku = '';
          el.goodsNameCus = '';
          this.$set(el, 'fnskuDisabled', false);
        }
        if (el.orderType == 1) {
          el.fnsku = '';
          el.goodsNameCus = '';
          this.$set(el, 'fnskuDisabled', false);
        } else {
          this.$set(el, 'fnskuDisabled', true);
        }
        if (el.orderType == 1) {
          this.$set(el, 'skuLabel', 'コード');
          this.$set(el, 'skuPlaceolder', '');
        }
        if (el.orderType == 0) {
          this.$set(el, 'skuPlaceolder', 'X00000001');
          this.$set(el, 'skuLabel', 'FNSKU');
        }
        if (el.orderType == 2) {
          this.$set(el, 'skuPlaceolder', 'hello-red');
          this.$set(el, 'skuLabel', 'YFFコード');
        }
        if (el.orderType == 3) {
          this.$set(el, 'skuPlaceolder', 'ICH123456789');
          this.$set(el, 'skuLabel', 'ZOZOコード');
        }
        if (el.orderType == 4) {
          this.$set(el, 'skuPlaceolder', '123456789');
          this.$set(el, 'skuLabel', 'JANコード');
        }
        if (el.agentFlag && el.agentFlag == 1) {
          if (el.chineseFreightFee == null) {
            el.chineseFreightFee = 0;
            //this.addFormInfo.addFormInfoRules[index].chineseFreightFee[0].required = true;
          }
          this.$set(el, 'freightDisabled', true);
        } else {
          el.chineseFreightFee = '';
          this.$set(el, 'freightDisabled', false);
          //this.addFormInfo.addFormInfoRules[index].chineseFreightFee[0].required = false;
        }
      });
      this.addFormInfo.tableData = [];
      this.addFormInfo.addFormInfoRules = [];
      this.$http.get('customer/getCustomerInfo').then((res) => {
        if (res.data.data.hotboomFlag != '1') {
          this.addFormInfo.tableData.map((obj) => {
            obj.agentFlag = this.agentFlagState;
            obj.trackingNumberCnType = true;
          });
          this.addFormInfo.addFormInfoRules.map((item) => {
            item.trackingNumberCn = [
              {
                required: true,
                message: this.$t('createOrder.createOrder62'),
                trigger: 'blur'
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: this.$t('createOrder.createOrder63'),
                trigger: 'blur'
              }
            ];
          });
          this.agentFlagType = true;
        } else {
          this.addFormInfo.tableData.map((obj) => {
            obj.agentFlag = this.agentFlagState;
          });
          this.agentFlagType = false;
        }
      });

      fromInfo.forEach((el) => {
        if (el.orderType == '0') {
          this.$set(el, 'fnskuDisabled', true);
          this.addFormInfo.addFormInfoRules.push({
            goodsCount: [
              {
                required: true,
                message: this.$t('createOrder.createOrder80'),
                trigger: 'blur'
              }
            ],
            colour: [
              {
                required: true,
                message: this.$t('createOrder.createOrder81'),
                trigger: 'blur'
              }
            ],
            price: [
              {
                required: true,
                message: this.$t('createOrder.createOrder82'),
                trigger: 'blur'
              }
            ],
            trackingNumberCn: [
              {
                required: true,
                message: this.$t('createOrder.createOrder62'),
                trigger: 'blur'
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: this.$t('createOrder.createOrder63'),
                trigger: 'blur'
              }
            ],
            chineseFreightFee: [
              {
                required: true,
                message: this.$t('createOrder.createOrder115'),
                trigger: 'blur'
              }
            ],
            fnsku: [
              {
                required: true,
                message: this.$t('createOrder.createOrder84'),
                trigger: 'blur'
              }
            ],
            goodsNameCus: [
              {
                required: true,
                message: this.$t('createOrder.createOrder114'),
                trigger: 'blur'
              }
            ],
            goodsName: [
              {
                required: false,
                message: this.$t('createOrder.createOrder85'),
                trigger: 'blur'
              }
            ],
            /* sender: [{ required: false, message: this.$t('address.address39') }],
            senderPhone: [
              {
                required: false,
                message: this.$t('address.address34'),
                trigger: 'blur'
              }
            ],
            sendAddress: [
              {
                required: false,
                message: this.$t('createOrder.createOrder86'),
                trigger: 'blur'
              }
            ],
            receiver: [{ required: false, message: this.$t('address.address39') }],
            receiverPhone: [
              {
                required: false,
                message: this.$t('address.address34'),
                trigger: 'blur'
              }
            ],
            zipCode: [
              {
                required: false,
                message: this.$t('address.address35'),
                trigger: 'blur'
              }
            ],
            receiverAddress: [
              {
                required: false,
                message: this.$t('createOrder.createOrder86'),
                trigger: 'blur'
              }
            ], */
            laundryLabelId: [
              {
                required: true,
                message: this.$t('createOrder.createOrder87'),
                trigger: 'blur'
              }
            ]
          });
        } else {
          el.goodsNameCus = '';
          this.addFormInfo.addFormInfoRules.push({
            goodsCount: [
              {
                required: true,
                message: this.$t('createOrder.createOrder80'),
                trigger: 'blur'
              }
            ],
            colour: [
              {
                required: true,
                message: this.$t('createOrder.createOrder81'),
                trigger: 'blur'
              }
            ],
            price: [
              {
                required: true,
                message: this.$t('createOrder.createOrder82'),
                trigger: 'blur'
              }
            ],
            trackingNumberCn: [
              {
                required: true,
                message: this.$t('createOrder.createOrder62'),
                trigger: 'blur'
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: this.$t('createOrder.createOrder63'),
                trigger: 'blur'
              }
            ],
            chineseFreightFee: [
              {
                required: true,
                message: this.$t('createOrder.createOrder115'),
                trigger: 'blur'
              }
            ],
            fnsku: [
              {
                required: false,
                message: this.$t('createOrder.createOrder84'),
                trigger: 'blur'
              }
            ],
            goodsNameCus: [
              {
                required: true,
                message: this.$t('createOrder.createOrder114'),
                trigger: 'blur'
              }
            ],
            goodsName: [
              {
                required: false,
                message: this.$t('createOrder.createOrder85'),
                trigger: 'blur'
              }
            ],
            /* sender: [{ required: true, message: this.$t('address.address39') }],
            senderPhone: [
              {
                required: true,
                message: this.$t('address.address34'),
                trigger: 'blur'
              }
            ],
            sendAddress: [
              {
                required: true,
                message: this.$t('createOrder.createOrder86'),
                trigger: 'blur'
              }
            ],
            receiver: [{ required: true, message: this.$t('address.address39') }],
            receiverPhone: [
              {
                required: true,
                message: this.$t('address.address34'),
                trigger: 'blur'
              }
            ],
            zipCode: [
              {
                required: true,
                message: this.$t('address.address35'),
                trigger: 'blur'
              }
            ],
            receiverAddress: [
              {
                required: true,
                message: this.$t('createOrder.createOrder86'),
                trigger: 'blur'
              }
            ], */
            laundryLabelId: [
              {
                required: true,
                message: this.$t('createOrder.createOrder87'),
                trigger: 'blur'
              }
            ]
          });
        }
      });
      this.addFormInfo.tableData = JSON.parse(JSON.stringify(fromInfo));
      /* this.addFormInfo.tableData.map((res) => {
        console.log('tableData', res);
        if (res.receiverCode === null || res.receiverCode === '') {
          res.receiver = '';
          res.receiverCode = '';
          res.receiverPhone = '';
          res.receiverAddress = '';
          res.zipCode = '';
        } else {
          this.$http
            .get('cms/configAddressInfo/list', {
              // 收件地址
              params: {
                addressNo: res.receiverCode,
                receiverName: '',
                type: '0',
                pageSize: 10,
                pageNum: 1
              }
            })
            .then((obj) => {
              obj.data.data.list.map((item) => {
                // console.log('收件人', item);
                this.add_addressList.receiverCode = item.addressNo;
                if (res.receiverCode === item.addressNo) {
                  // res.receiverCode = item.addressNo
                  res.rprovence = item.provenceName;
                  res.rcity = item.cityName;
                  res.rarea = item.areaName;
                  res.receiver = item.receiverName;
                  res.receiverPhone = item.receiverPhone;
                  res.zipCode = item.postcode;
                  res.receiverzipCode = item.postcode;
                  res.receiverAddress = item.addressInfo;
                  res.receiverprovence = parseInt(item.provence);
                  res.receivercity = parseInt(item.city);
                  res.receiverarea = parseInt(item.area);
                  res.receiveraddressInfo = item.addressInfo;
                  res.receivernote = item.postcode;
                  res.receiverdefaultAddress = item.defaultAddress;
                  res.receiverid = item.id;
                  this.randomKey = Math.random();
                }
              });
            });
        }
        if (res.senderCode === null || res.senderCode === '') {
          res.sender = '';
          res.senderPhone = '';
          res.sendAddress = '';
        } else {
          this.$http
            .get('cms/configAddressInfo/list', {
              // 发货地址
              params: {
                addressNo: res.senderCode,
                receiverName: '',
                type: '1',
                pageSize: 10,
                pageNum: 1
              }
            })
            .then((obj) => {
              obj.data.data.list.map((item) => {
                // console.log('发件人=====', item);
                this.add_addressList.senderCode = item.addressNo;
                if (res.senderCode === item.addressNo) {
                  // res.senderCode = item.addressNo
                  res.sprovence = item.provenceName;
                  res.scity = item.cityName;
                  res.sarea = item.areaName;
                  res.sender = item.receiverName;
                  res.senderPhone = item.receiverPhone;
                  res.sendAddress = item.addressInfo;
                  res.addressInfo = item.addressInfo;
                  // res.sendernote = item.postcode
                  res.senderprovence = parseInt(item.provence);
                  res.sendercity = parseInt(item.city);
                  res.senderarea = parseInt(item.area);
                  res.senderaddressInfo = item.addressInfo;
                  res.senderzipCode = item.postcode;
                  // res.zipCode = item.postcode
                  res.senderdefaultAddress = item.defaultAddress;
                  res.senderid = item.id;
                  this.randomKey = Math.random();
                }
              });
            });
        }
        this.$nextTick(() => {
          this.$set(res, 0, JSON.parse(JSON.stringify(res)));
          this.randomKey = Math.random();
        });
      });
 */
      if (this.addFormInfo.tableData[0].agentFlag == 1) {
        this.addFormInfo.addFormInfoRules[0].trackingNumberCn = [
          {
            required: false,
            message: this.$t('createOrder.createOrder62'),
            trigger: 'blur'
          }
        ];
        this.addFormInfo.tableData[0].trackingNumberCnType = false;
        this.addFormInfo.addFormInfoRules[0].chineseFreightFee = [
          {
            required: true,
            message: this.$t('createOrder.createOrder115'),
            trigger: 'blur'
          }
        ];
      } else {
        this.addFormInfo.addFormInfoRules[0].trackingNumberCn = [
          {
            required: true,
            message: this.$t('createOrder.createOrder62'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: this.$t('createOrder.createOrder63'),
            trigger: 'blur'
          }
        ];
        this.addFormInfo.tableData[0].trackingNumberCnType = true;
        //this.addFormInfo.addFormInfoRules[0].chineseFreightFee.required = false;
      }
    } else {
      await this.SelectDefaultAddress();
      this.addFormInfo.tableData.push({
        trackingNumberCn: '',
        taobaoUrl: '',
        goodsName: '',
        goodsCount: '',
        colour: '',
        goodsSize: '',
        price: '',
        goodsNumber: '',
        categoryFlag: '0',
        agentFlag: this.agentFlagType ? '0' : '1',
        orderType: '1',
        putIntent: '',
        laundryLabelId: '',
        fnsku: '',
        configCheckProjectArray: 'baseCheck',
        configCheckProjectOrigin: ['baseCheck'],
        /* sender: '',
        senderPhone: '',
        zipCode: '',
        sendAddress: '',
        senderCode: this.senderLis.senderCode,
        receiverCode: this.receiverLis.receiverCode, */
        customerRemark: '',
        pictureUrl: '',
        pictureName: '',
        pdfName: '',
        pdfUrl: '',
        inspectionFileName: '',
        inspectionFileUrl: '',
        trackingNumberCnType: this.agentFlagType,
        isTempDisabled: false,
        fnskuDisabled: false,
        freightDisabled: true,
        chineseFreightFee: 0,
        goodsNameCus: '',
      });
      this.addFormInfo.addFormInfoRules.push({
        goodsCount: [{ required: true, message: this.$t('createOrder.createOrder80'), trigger: 'blur' }],
        colour: [{ required: true, message: this.$t('createOrder.createOrder81'), trigger: 'blur' }],
        price: [{ required: true, message: this.$t('createOrder.createOrder82'), trigger: 'blur' }],
        trackingNumberCn: [
          { required: true, message: this.$t('createOrder.createOrder62'), trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: this.$t('createOrder.createOrder63'),
            trigger: 'blur'
          }
        ],
        chineseFreightFee: [{ required: true, message: this.$t('createOrder.createOrder115'), trigger: 'blur' }],
        fnsku: [{ required: false, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }],
        goodsNameCus: [{ required: true, message: this.$t('createOrder.createOrder114'), trigger: 'blur' }],
        goodsName: [{ required: false, message: this.$t('createOrder.createOrder85'), trigger: 'blur' }],
        /* sender: [{ required: true, message: this.$t('address.address39') }],
        senderPhone: [{ required: true, message: this.$t('address.address34'), trigger: 'blur' }],
        sendAddress: [{ required: true, message: this.$t('createOrder.createOrder86'), trigger: 'blur' }],
        receiver: [{ required: true, message: this.$t('address.address39') }],
        receiverPhone: [{ required: true, message: this.$t('address.address34'), trigger: 'blur' }],
        zipCode: [{ required: true, message: this.$t('address.address35'), trigger: 'blur' }],
        receiverAddress: [{ required: true, message: this.$t('createOrder.createOrder86'), trigger: 'blur' }], */
        laundryLabelId: [
          {
            required: true,
            message: this.$t('createOrder.createOrder87'),
            trigger: 'blur'
          }
        ]
      });
      if (this.addFormInfo.tableData.agentFlag === '0') {
        this.addFormInfo.addFormInfoRules[0].trackingNumberCn[0].required = true;
        //this.addFormInfo.addFormInfoRules[0].chineseFreightFee[0].required = false;
      } else {
        this.addFormInfo.addFormInfoRules[0].trackingNumberCn[0].required = false;
        this.addFormInfo.addFormInfoRules[0].chineseFreightFee[0].required = true;
      }
      // this.SelectDefaultAddress()
    }
    //this.productForm.quantity = this.countTotalStock(this.productArray);
    let sorPriceArr = this.countSortPrice(this.productArray);
    this.minPrice = sorPriceArr[0];
    this.maxPrice = sorPriceArr[sorPriceArr.length - 1];
    this.getInspectionOption();
    this.getLaundryLabelOption();

    // //左侧图片默认选中
    // if(this.imgUrls[0]){
    //     this.imgUrls[0].select=1;
    // }
    this.randomKey = Math.random();
  }
};
</script>
<style lang="less" scoped>
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.address {
  width: 90%;
  margin: 0 auto 20px;
  border: 1px solid #d5d3d3;
}

.active {
  border-color: red;
}

.demo-form-inline /deep/ .el-form-item__content {
  width: 100%;
}

.Accessories-title {
  height: 60px;
  line-height: 60px;
  text-align: right;
  padding-right: 10px;
}

.Accessories {
  border-top: 1px solid #e5e9f8;
  border-right: 1px solid #e5e9f8;
}

.Accessories .el-col {
  height: 30px;
  line-height: 30px;
  padding: 0 2px;
  border-left: 1px solid #e5e9f8;
  border-bottom: 1px solid #e5e9f8;
  text-align: center;
  /* overflow:auto; */
}

.add-form {
  padding-top: 10px;
}

.add-form /deep/ .el-form-item__label {
  text-align: left !important;
  padding: 0 5px 0 0 !important;
}

.add-form .el-form-item {
  margin-bottom: 12px;
}

.add-form /deep/ .el-form-item__error {
  padding-top: 0 !important;
}

.add-form /deep/ .el-input--small .el-input__inner {
  padding-left: 2px !important;
}

.mini-label /deep/ .el-form-item__content {
  margin-left: 16px !important;
}

.mini-label /deep/ .el-form-item__label-wrap {
  margin-left: 0 !important;
}

.no-label /deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.no-label /deep/ .el-form-item__label-wrap {
  margin-left: 0 !important;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 5px !important;
}

.add-form /deep/ .el-table .cell {
  padding: 0 0 0 5px !important;
}

.addOrder-btn-container {
  padding-top: 10px;
}

/* dialog */
ul,
li {
  list-style: none;
}

.app-container {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.left {
  float: left;
}

.overflow {
  overflow: hidden;
}

.picture-container {
  width: 40%;
  padding: 10px;
}

.attr-container {
  width: 60%;
  padding: 10px;
}

.product-detail {
  width: 100%;
  overflow: auto;
}

.lg-img {
  width: 230px;
  height: 230px;
  margin: 0 auto;
}

.lg-img img {
  width: 230px;
  height: 230px;
}

.bottom-img {
  width: 260px;
  margin: 10px auto 0 auto;
  overflow: hidden;
}

.sm-img {
  float: left;
  margin-right: 6px;
  border: 2px solid transparent;
  overflow: hidden;
}

.sm-img-selected {
  float: left;
  margin-right: 6px;
  border: 2px solid darkred;
  overflow: hidden;
}

.sm-img img {
  width: 40px;
  height: 40px;
  float: left;
}

.name-container {
  min-height: 21px;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

.tag-top {
  width: 33%;
}

.title-top {
  display: inline-block;
  margin-right: 6px;
  color: #6c6c6c;
  width: 70px;
}

.title {
  display: inline-block;
  margin-right: 6px;
  color: #6c6c6c;
  width: 66px;
}

.attr-tag {
  padding: 0 8px;
  border: 1px solid #ccc;
  cursor: pointer;
  margin-right: 5px;
  height: 30px;
  line-height: 30px;
  margin-top: 3px;
}

.attr-tag-checked {
  border: 1px solid darkred;
  color: darkred;
}

.attr-tag:hover {
  border: 1px solid darkred !important;
}

.price-container,
.specification-container,
.stock-container {
  margin-top: 20px;
}

.price-container .price,
.price-container .act-price {
  color: red;
  font-size: 30px;
}

.attr-row {
  margin-top: 15px;
}

/* .unit{
    color: red;
    font-size: 16px;
} */
.product-detail /deep/ .el-form-item__label {
  text-align: left;
}

.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}

.upload-demo {
  float: right;
  margin-left: 10px;
}
.line-height-30 /deep/ .el-form-item__content {
  line-height: 30px !important;
}
.style-table {
  /deep/ .el-form-item__label-wrap {
    margin-left: 0 !important;
    margin-bottom: -10px;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1550px) {
  .row-left {
    width: 40% !important;
  }
  .row-right {
    width: 60% !important;
  }
  .search-btn {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
